(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('theme-ui'), require('@dasa-health/icons'), require('styled-components'), require('@dasa-health/alma-tokens'), require('@dasa-health/alma-react'), require('styled-system'), require('react-outside-click-handler')) :
    typeof define === 'function' && define.amd ? define(['exports', 'react', 'theme-ui', '@dasa-health/icons', 'styled-components', '@dasa-health/alma-tokens', '@dasa-health/alma-react', 'styled-system', 'react-outside-click-handler'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["dasa-components"] = {}, global.React, global.ThemeUi, global["DasaHealth/icons"], global.StyledComponents, global["DasaHealth/almaTokens"], global["DasaHealth/almaReact"], global.StyledSystem, global.ReactOutsideClickHandler));
})(this, (function (exports, React, themeUi, icons, styled, almaTokens, almaReact, styledSystem, OutsideClickHandler) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    function _interopNamespace(e) {
        if (e && e.__esModule) return e;
        var n = Object.create(null);
        if (e) {
            Object.keys(e).forEach(function (k) {
                if (k !== 'default') {
                    var d = Object.getOwnPropertyDescriptor(e, k);
                    Object.defineProperty(n, k, d.get ? d : {
                        enumerable: true,
                        get: function () { return e[k]; }
                    });
                }
            });
        }
        n["default"] = e;
        return Object.freeze(n);
    }

    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
    var React__namespace = /*#__PURE__*/_interopNamespace(React);
    var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
    var OutsideClickHandler__default = /*#__PURE__*/_interopDefaultLegacy(OutsideClickHandler);

    var __defProp$D = Object.defineProperty;
    var __defProps$k = Object.defineProperties;
    var __getOwnPropDescs$k = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$D = Object.getOwnPropertySymbols;
    var __hasOwnProp$D = Object.prototype.hasOwnProperty;
    var __propIsEnum$D = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$D = (obj, key, value) => key in obj ? __defProp$D(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$D = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$D.call(b, prop))
          __defNormalProp$D(a, prop, b[prop]);
      if (__getOwnPropSymbols$D)
        for (var prop of __getOwnPropSymbols$D(b)) {
          if (__propIsEnum$D.call(b, prop))
            __defNormalProp$D(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$k = (a, b) => __defProps$k(a, __getOwnPropDescs$k(b));
    const alertBase = {
      borderRadius: "small",
      border: "1px solid",
      color: "text",
      fontSize: "small",
      fontWeight: "normal",
      lineHeight: 2,
      p: 4
    };
    const alertsTheme = {
      primary: __spreadProps$k(__spreadValues$D({}, alertBase), {
        bg: "brand.primary.97",
        borderColor: "brand.primary.90",
        " span": {
          color: "feedback.primary.50"
        }
      }),
      secondary: __spreadProps$k(__spreadValues$D({}, alertBase), {
        bg: "lightBlues.100",
        borderColor: "lightBlues.100",
        " span": {
          color: "lightBlues.50"
        }
      }),
      info: __spreadProps$k(__spreadValues$D({}, alertBase), {
        bg: "brand.primary.97",
        borderColor: "brand.primary.90",
        " span": {
          color: "feedback.primary.50"
        }
      }),
      success: __spreadProps$k(__spreadValues$D({}, alertBase), {
        bg: "feedback.success.97",
        borderColor: "feedback.success.90",
        " span": {
          color: "feedback.success.50"
        }
      }),
      error: __spreadProps$k(__spreadValues$D({}, alertBase), {
        bg: "feedback.danger.97",
        borderColor: "feedback.danger.90",
        " span": {
          color: "feedback.danger.50"
        }
      }),
      alert: __spreadProps$k(__spreadValues$D({}, alertBase), {
        bg: "feedback.alert.97",
        borderColor: "feedback.alert.90",
        " span": {
          color: "feedback.alert.50"
        }
      }),
      simple: __spreadProps$k(__spreadValues$D({}, alertBase), {
        bg: "brand.primary.90",
        boxShadow: "blackLow",
        border: 0
      })
    };
    const AlertHeader = styled__default["default"].header`
    align-content: center;
    display: flex;
    flex-wrap: wrap;

    h4 {
        color: ${({ theme }) => theme.colors.grays[40]};
        font-weight: ${({ theme }) => theme.fontWeights.normal};
        margin: 0;

        strong {
            color: ${({ theme }) => theme.colors.black};
            font-weight: ${({ theme }) => theme.fontWeights.bold};
            font-size: ${({ theme }) => theme.fontSizes[2]};
        }
    }
`;

    var __defProp$C = Object.defineProperty;
    var __getOwnPropSymbols$C = Object.getOwnPropertySymbols;
    var __hasOwnProp$C = Object.prototype.hasOwnProperty;
    var __propIsEnum$C = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$C = (obj, key, value) => key in obj ? __defProp$C(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$C = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$C.call(b, prop))
          __defNormalProp$C(a, prop, b[prop]);
      if (__getOwnPropSymbols$C)
        for (var prop of __getOwnPropSymbols$C(b)) {
          if (__propIsEnum$C.call(b, prop))
            __defNormalProp$C(a, prop, b[prop]);
        }
      return a;
    };
    var __objRest$q = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$C.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$C)
        for (var prop of __getOwnPropSymbols$C(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$C.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const Icon = React.forwardRef((_a, ref) => {
      var _b = _a, { variant, sx = {}, color, size = "medium" } = _b, props = __objRest$q(_b, ["variant", "sx", "color", "size"]);
      return /* @__PURE__ */ React__default["default"].createElement(themeUi.IconButton, __spreadValues$C({
        as: "span",
        p: 1,
        ref,
        sx: __spreadValues$C({
          color: variant || color,
          borderRadius: "pill",
          border: "none",
          width: "auto",
          height: "auto",
          "& > svg": {
            fill: "currentcolor",
            fontSize: size
          }
        }, sx)
      }, props));
    });

    var __defProp$B = Object.defineProperty;
    var __getOwnPropSymbols$B = Object.getOwnPropertySymbols;
    var __hasOwnProp$B = Object.prototype.hasOwnProperty;
    var __propIsEnum$B = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$B = (obj, key, value) => key in obj ? __defProp$B(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$B = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$B.call(b, prop))
          __defNormalProp$B(a, prop, b[prop]);
      if (__getOwnPropSymbols$B)
        for (var prop of __getOwnPropSymbols$B(b)) {
          if (__propIsEnum$B.call(b, prop))
            __defNormalProp$B(a, prop, b[prop]);
        }
      return a;
    };
    const Alert = ({ sx, children, type = "alert", heading = "AVISO" }) => /* @__PURE__ */ React__default["default"].createElement(themeUi.Box, {
      sx: __spreadValues$B(__spreadValues$B({}, sx), alertsTheme[type])
    }, /* @__PURE__ */ React__default["default"].createElement(AlertHeader, null, type === "alert" ? /* @__PURE__ */ React__default["default"].createElement(Icon, {
      className: type,
      mr: 2,
      size: "large"
    }, /* @__PURE__ */ React__default["default"].createElement(icons.SystemBoldWarning, null)) : "", /* @__PURE__ */ React__default["default"].createElement("h4", null, type === "alert" ? heading : /* @__PURE__ */ React__default["default"].createElement("strong", null, heading))), children);

    var __defProp$A = Object.defineProperty;
    var __getOwnPropSymbols$A = Object.getOwnPropertySymbols;
    var __hasOwnProp$A = Object.prototype.hasOwnProperty;
    var __propIsEnum$A = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$A = (obj, key, value) => key in obj ? __defProp$A(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$A = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$A.call(b, prop))
          __defNormalProp$A(a, prop, b[prop]);
      if (__getOwnPropSymbols$A)
        for (var prop of __getOwnPropSymbols$A(b)) {
          if (__propIsEnum$A.call(b, prop))
            __defNormalProp$A(a, prop, b[prop]);
        }
      return a;
    };
    const colorPrimitives = {
      blues: {
        10: "#000B33",
        20: "#001666",
        30: "#002199",
        40: "#002CCC",
        50: "#0037FF",
        60: "#335FFF",
        70: "#6687FF",
        80: "#99AFFF",
        90: "#CCD7FF",
        97: "#F0F3FF",
        100: "#F0F3FF"
      },
      lightBlues: {
        10: "#050f2e",
        20: "#0a3a5c",
        30: "#0f578a",
        40: "#1474b8",
        50: "#1990e5",
        60: "#47a7eb",
        70: "#71bdf3",
        80: "#a3d3f5",
        90: "#d1e9fa",
        100: "#f0f9ff"
      },
      grays: {
        10: "#18191b",
        20: "#303236",
        30: "#494b50",
        40: "#61636b",
        50: "#797c86",
        60: "#94969e",
        70: "#afb1b6",
        80: "#c9cbcf",
        90: "#e4e5e7",
        97: "#F7F7F8",
        100: "#f7f7f8"
      },
      greens: {
        10: "#0a2913",
        20: "#145127",
        30: "#1f7a3a",
        40: "#29a34e",
        50: "#30c05b",
        60: "#5cd681",
        70: "#85e0a0",
        80: "#adeac0",
        90: "#d6f5df",
        97: "#f3fcf5",
        100: "#f3fcf5"
      },
      oranges: {
        10: "#331400",
        20: "#662900",
        30: "#993d00",
        40: "#cc5200",
        50: "#fa6400",
        60: "#ff8433",
        70: "#ffa366",
        80: "#ffc299",
        90: "#ffe0cc",
        97: "#fff6f0",
        100: "#fff6f0"
      },
      reds: {
        10: "#2e050e",
        20: "#5c0a1b",
        30: "#890f29",
        40: "#b71537",
        50: "#e51a45",
        60: "#ea486a",
        70: "#ef758f",
        80: "#f5a3b4",
        90: "#fad1da",
        97: "#fdf1f4",
        100: "#fdf1f4"
      },
      violets: {
        10: "#20052e",
        20: "#410a5c",
        30: "#610f8a",
        40: "#8114b8",
        50: "#a119e5",
        60: "#b547eb",
        70: "#c871f3",
        80: "#db9efa",
        90: "#eeccff",
        100: "#faf0ff"
      },
      whites: {
        8: "rgba(255, 255, 255, 0.08)",
        16: "rgba(255, 255, 255, 0.16)",
        24: "rgba(255, 255, 255, 0.24)",
        48: "rgba(255, 255, 255, 0.48)",
        64: "rgba(255, 255, 255, 0.64)",
        80: "rgba(255, 255, 255, 0.8)",
        100: "#FFFFFF"
      },
      yellows: {
        10: "#2e2405",
        20: "#5c480a",
        30: "#8a6c0f",
        40: "#b88f14",
        50: "#e6b319",
        60: "#ebc247",
        70: "#f0d275",
        80: "#f5e1a3",
        90: "#faf0d1",
        97: "#fdfaf1",
        100: "#fdfaf1"
      },
      blacks: {
        8: "rgba(0, 0, 0, 0.08)",
        16: "rgba(0, 0, 0, 0.16)",
        24: "rgba(0, 0, 0, 0.24);",
        48: "rgba(0, 0, 0, 0.48)",
        64: "rgba(0, 0, 0, 0.64)",
        80: "rgba(0, 0, 0, 0.8)",
        100: "#000000"
      }
    };
    const { blacks, blues, grays, greens, lightBlues, oranges, reds, violets, yellows, whites } = colorPrimitives;
    const colorAliases = {
      blue: blues[50],
      gray: grays[50],
      green: greens[50],
      lightBlue: lightBlues[50],
      orange: oranges[50],
      red: reds[50],
      violet: violets[50],
      yellow: yellows[50],
      black: blacks[100],
      white: whites[100]
    };
    const { blue, green, white, black, lightBlue, orange, red, violet, yellow } = colorAliases;
    const colorBrand = {
      brand: {
        primary: {
          10: blues[10],
          20: blues[20],
          30: blues[30],
          40: blues[40],
          50: blues[50],
          60: blues[60],
          70: blues[70],
          80: blues[80],
          90: blues[90],
          97: blues[97],
          100: blues[100]
        },
        accent: {
          10: oranges[10],
          20: oranges[20],
          30: oranges[30],
          40: oranges[40],
          50: oranges[50],
          60: oranges[60],
          70: oranges[70],
          80: oranges[80],
          90: oranges[90],
          97: oranges[97],
          100: oranges[100]
        },
        variant: {
          10: oranges[10],
          20: oranges[20],
          30: oranges[30],
          40: oranges[40],
          50: oranges[50],
          60: oranges[60],
          70: oranges[70],
          80: oranges[80],
          90: oranges[90],
          97: oranges[97],
          100: oranges[100]
        }
      },
      feedback: {
        danger: {
          10: reds[10],
          20: reds[20],
          30: reds[30],
          40: reds[40],
          50: reds[50],
          60: reds[60],
          70: reds[70],
          80: reds[80],
          90: reds[90],
          97: reds[97],
          100: reds[100]
        },
        alert: {
          10: yellows[10],
          20: yellows[20],
          30: yellows[30],
          40: yellows[40],
          50: yellows[50],
          60: yellows[60],
          70: yellows[70],
          80: yellows[80],
          90: yellows[90],
          97: yellows[97],
          100: yellows[100]
        },
        success: {
          10: greens[10],
          20: greens[20],
          30: greens[30],
          40: greens[40],
          50: greens[50],
          60: greens[60],
          70: greens[70],
          80: greens[80],
          90: greens[90],
          97: greens[97],
          100: greens[100]
        }
      }
    };
    const colors = __spreadValues$A(__spreadValues$A(__spreadValues$A({
      accent: orange,
      background: white,
      blackfade16: "rgba(0, 0, 0, 0.16)",
      blackfade24: "rgba(0, 0, 0, 0.24)",
      blackfade48: "rgba(0, 0, 0, 0.48)",
      blackfade64: "rgba(0, 0, 0, 0.64)",
      blackfade8: "rgba(0, 0, 0, 0.08)",
      blackfade80: "rgba(0, 0, 0, 0.8)",
      whitefade16: "rgba(255, 255, 255, 0.16)",
      whitefade24: "rgba(255, 255, 255, 0.24)",
      whitefade48: "rgba(255, 255, 255, 0.48)",
      whitefade8: "rgba(255, 255, 255, 0.08)",
      whitefade80: "rgba(255, 255, 255, 0.8)",
      highlight: violet,
      primary: blue,
      secondary: lightBlue,
      muted: grays[80],
      alert: yellow,
      success: green,
      error: red,
      text: black
    }, colorBrand), colorPrimitives), colorAliases);

    const radii = {
      small: "4px",
      medium: "8px",
      large: "16px",
      pill: "20rem"
    };

    const shadows = {
      blueHigh: "0px 8px 16px rgba(54, 77, 148, 0.24)",
      blueLow: "0px 3px 6px rgba(54, 77, 148, 0.24)",
      blueMedium: "0px 4px 8px rgba(54, 77, 148, 0.24)",
      blueVHigh: "0px 16px 32px rgba(54, 77, 148, 0.24)",
      blueVLow: "0px 2px 4px rgba(54, 77, 148, 0.24)",
      high: "0px 8px 16px rgba(0, 0, 0, 0.24)",
      low: "0px 3px 6px rgba(0, 0, 0, 0.24)",
      medium: "0px 4px 8px rgba(0, 0, 0, 0.24)",
      vHigh: "0px 16px 32px rgba(0, 0, 0, 0.24)",
      vLow: "0px 2px 4px rgba(0, 0, 0, 0.24)",
      blackLow: "0px 2px 4px rgba(18, 18, 18, 0.24)"
    };

    var __defProp$z = Object.defineProperty;
    var __defProps$j = Object.defineProperties;
    var __getOwnPropDescs$j = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$z = Object.getOwnPropertySymbols;
    var __hasOwnProp$z = Object.prototype.hasOwnProperty;
    var __propIsEnum$z = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$z = (obj, key, value) => key in obj ? __defProp$z(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$z = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$z.call(b, prop))
          __defNormalProp$z(a, prop, b[prop]);
      if (__getOwnPropSymbols$z)
        for (var prop of __getOwnPropSymbols$z(b)) {
          if (__propIsEnum$z.call(b, prop))
            __defNormalProp$z(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$j = (a, b) => __defProps$j(a, __getOwnPropDescs$j(b));
    const spaceBase = {
      0: "0",
      1: "0.25em",
      2: "0.5em",
      3: "0.75em",
      4: "1em",
      5: "1.25em",
      6: "1.5em",
      7: "1.75em",
      8: "2em",
      9: "2.25em",
      10: "2.5em",
      11: "2.75em",
      12: "3em",
      13: "3.25em"
    };
    const space = __spreadProps$j(__spreadValues$z({}, spaceBase), {
      small: spaceBase[2],
      medium: spaceBase[4],
      large: spaceBase[6]
    });

    const borderWidths = { 0: 0, 1: "1px" };

    var __defProp$y = Object.defineProperty;
    var __defProps$i = Object.defineProperties;
    var __getOwnPropDescs$i = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$y = Object.getOwnPropertySymbols;
    var __hasOwnProp$y = Object.prototype.hasOwnProperty;
    var __propIsEnum$y = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$y = (obj, key, value) => key in obj ? __defProp$y(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$y = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$y.call(b, prop))
          __defNormalProp$y(a, prop, b[prop]);
      if (__getOwnPropSymbols$y)
        for (var prop of __getOwnPropSymbols$y(b)) {
          if (__propIsEnum$y.call(b, prop))
            __defNormalProp$y(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$i = (a, b) => __defProps$i(a, __getOwnPropDescs$i(b));
    function fontStack(fonts2) {
      return fonts2.map((font) => font.includes(" ") ? `"${font}"` : font).join(", ");
    }
    const typography = {
      fontSizes: {
        0: "0.75em",
        1: "1em",
        2: "1.125em",
        3: "1.25em",
        4: "1.5em",
        5: "2em",
        6: "2.75em",
        7: "3.75em",
        xsmall: "0.625em",
        xmedium: "0.875em",
        xxmedium: "0.8125em",
        xxlarge: "2.5em"
      },
      lineHeights: {
        condensed: 1.25,
        condensedUltra: 1,
        default: 1.5
      }
    };
    const { fontSizes: fontSizes$1, lineHeights: lineHeights$1 } = typography;
    const aliasesFontSizes = __spreadProps$i(__spreadValues$y({}, fontSizes$1), {
      small: fontSizes$1[0],
      medium: fontSizes$1[1],
      large: fontSizes$1[3]
    });
    const newTypography = __spreadProps$i(__spreadValues$y({}, typography), {
      lineHeights: lineHeights$1,
      fontSizes: __spreadValues$y({}, aliasesFontSizes)
    });
    const fonts = {
      normal: fontStack(["Montserrat", "Dasa Sans", "sans-serif"])
    };
    const fontWeights = {
      extrabold: 700,
      bold: 600,
      light: 300,
      normal: 400,
      semibold: 500
    };

    const breakpoints = ["37.5em", "52.5em", "64em", "90em"];

    const forms = {
      label: {
        fontSize: 1,
        color: "grays.60",
        fontWeight: "normal",
        width: "auto",
        margin: 0
      },
      input: {
        borderColor: "grays.60",
        borderWidth: 1,
        outline: "none",
        fontFamily: "normal",
        "&:focus": {
          borderColor: "primary",
          borderWidth: 1,
          outline: "none"
        }
      },
      select: {
        borderColor: "grays.60",
        fontFamily: "normal",
        "&:focus": {
          borderColor: "primary",
          borderWidth: 1,
          outline: "none"
        }
      },
      textarea: {
        borderColor: "grays.60",
        fontFamily: "normal",
        "&:focus": {
          borderColor: "primary",
          borderWidth: 1,
          outline: "none"
        }
      },
      slider: {
        bg: "muted"
      }
    };

    const text = {
      default: {
        color: "text"
      },
      h0: {
        fontSize: 7,
        fontWeight: "bold"
      },
      h1: {
        fontSize: 6,
        fontWeight: "bold"
      },
      h2: {
        fontSize: 5,
        fontWeight: "bold"
      },
      h3: {
        fontSize: 4,
        fontWeight: "bold"
      },
      h4: {
        fontSize: 3,
        fontWeight: "bold"
      },
      h5: {
        fontSize: 2,
        fontWeight: "bold"
      },
      h6: {
        fontSize: 1,
        fontWeight: "bold"
      }
    };

    const sizes = {
      large: "1012px",
      medium: "768px",
      small: "544px"
    };

    const { lineHeights, fontSizes } = newTypography;
    const theme = {
      borderWidths,
      breakpoints,
      colors,
      fontSizes,
      fontWeights,
      fonts,
      forms,
      lineHeights,
      radii,
      shadows,
      space,
      sizes,
      text
    };
    const navTheme = almaReact.getCustomTheme(almaTokens.navTokens);
    const almaNavTheme = themeUi.merge(theme, navTheme);

    const GlobalStyles = styled.createGlobalStyle`
* {
    font-family: 'Montserrat', 'Dasa Sans', sans-serif;
    padding: 0;
    margin: 0;
    line-height: ${({ theme }) => theme.lineHeights.default};
    outline: none;
    h0 {
        font-size: ${({ theme }) => theme.fontSizes[7]};
    };
    h1 {
        font-size: ${({ theme }) => theme.fontSizes.xxlarge};
    };
    h2 {
        font-size: ${({ theme }) => theme.fontSizes[4]};
    };
    h3 {
        font-size: ${({ theme }) => theme.fontSizes.large};
    };
    h4 {
        font-size: ${({ theme }) => theme.fontSizes[2]};
    };
    h5 {
        font-size: ${({ theme }) => theme.fontSizes.medium};
    };
    h6 {
        font-size: ${({ theme }) => theme.fontSizes.xmedium};
    };
    a {
        text-decoration-line: underline;
        color: ${({ theme }) => theme.colors.primary};
    };
    pre {
        font-family: monospace;
        overflow-x: auto;
        code {
            color: inherit;
        };
    };
    code {
        font-family: monospace;
        font-size: inherit;
    };
    table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0;
    };
    th {
        text-align: left;
        border-bottom-style: solid;
    };
    td {
        text-align: left;
        border-bottom-style: solid;
    };
    img {
        max-width: 100%;
    };
}
`;

    const DasaProvider = ({ children }) => /* @__PURE__ */ React__default["default"].createElement(styled.ThemeProvider, {
      theme
    }, /* @__PURE__ */ React__default["default"].createElement(themeUi.ThemeProvider, {
      theme
    }, /* @__PURE__ */ React__default["default"].createElement(GlobalStyles, null), /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, children)));

    var __defProp$x = Object.defineProperty;
    var __defProps$h = Object.defineProperties;
    var __getOwnPropDescs$h = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$x = Object.getOwnPropertySymbols;
    var __hasOwnProp$x = Object.prototype.hasOwnProperty;
    var __propIsEnum$x = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$x = (obj, key, value) => key in obj ? __defProp$x(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$x = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$x.call(b, prop))
          __defNormalProp$x(a, prop, b[prop]);
      if (__getOwnPropSymbols$x)
        for (var prop of __getOwnPropSymbols$x(b)) {
          if (__propIsEnum$x.call(b, prop))
            __defNormalProp$x(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$h = (a, b) => __defProps$h(a, __getOwnPropDescs$h(b));
    const RoundedAvatarContansts = {
      24: {
        fontSize: "xsmall",
        width: "24px",
        size: "24px"
      },
      32: {
        fontSize: "small",
        width: "32px",
        size: "32px"
      },
      40: {
        fontSize: "xmedium",
        width: "40px",
        size: "40px"
      },
      48: {
        fontSize: "medium",
        width: "48px",
        size: "48px"
      },
      56: {
        fontSize: "large",
        width: "56px",
        size: "56px"
      }
    };
    Object.keys(RoundedAvatarContansts)[0];
    const SquareAvatarContansts = __spreadProps$h(__spreadValues$x({}, RoundedAvatarContansts), {
      64: {
        fontSize: "medium",
        width: "64px",
        size: "64px"
      }
    });

    var __defProp$w = Object.defineProperty;
    var __defProps$g = Object.defineProperties;
    var __getOwnPropDescs$g = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$w = Object.getOwnPropertySymbols;
    var __hasOwnProp$w = Object.prototype.hasOwnProperty;
    var __propIsEnum$w = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$w = (obj, key, value) => key in obj ? __defProp$w(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$w = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$w.call(b, prop))
          __defNormalProp$w(a, prop, b[prop]);
      if (__getOwnPropSymbols$w)
        for (var prop of __getOwnPropSymbols$w(b)) {
          if (__propIsEnum$w.call(b, prop))
            __defNormalProp$w(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$g = (a, b) => __defProps$g(a, __getOwnPropDescs$g(b));
    var __objRest$p = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$w.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$w)
        for (var prop of __getOwnPropSymbols$w(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$w.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const Box = React__default["default"].forwardRef((_a, ref) => {
      var _b = _a, { children, fullWidth, width, flexVal, sx } = _b, props = __objRest$p(_b, ["children", "fullWidth", "width", "flexVal", "sx"]);
      return /* @__PURE__ */ React__default["default"].createElement(themeUi.Box, __spreadProps$g(__spreadValues$w({
        sx: __spreadValues$w({
          flex: flexVal,
          width: fullWidth ? "100%" : width
        }, sx)
      }, props), {
        ref
      }), children);
    });

    const AvatarContainer = styled__default["default"](Box)`
    display: inline-flex;
    justify-content: center;
    place-items: center;
    box-sizing: border-box;
    font-weight: 400;
    margin: 8px;
    overflow: hidden;
    position: relative;
`;
    const AvatarInitials = styled__default["default"].span`
    position: absolute;
    margin: auto;
`;
    const AvatarImage = styled__default["default"].img`
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;
    const avatarThemeStyle = {
      color: "grays.40",
      backgroundColor: "grays.97"
    };

    const head = (arr) => arr && arr.length ? arr[0] : void 0;

    const portugueseNameArticles = ["da", "de", "do"];
    const getInitials = (text = "") => {
      const filteredNames = text.trim().split(/\W+/gi).filter((name) => !portugueseNameArticles.includes(name.toLowerCase()));
      const filteredNamesSize = filteredNames.length;
      if (filteredNamesSize <= 0) {
        return "";
      }
      if (filteredNamesSize === 1) {
        return head(filteredNames).slice(0, 2).toUpperCase();
      }
      return `${filteredNames[0].charAt(0)}${filteredNames[filteredNamesSize - 1].charAt(0)}`.toUpperCase();
    };

    var __defProp$v = Object.defineProperty;
    var __getOwnPropSymbols$v = Object.getOwnPropertySymbols;
    var __hasOwnProp$v = Object.prototype.hasOwnProperty;
    var __propIsEnum$v = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$v = (obj, key, value) => key in obj ? __defProp$v(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$v = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$v.call(b, prop))
          __defNormalProp$v(a, prop, b[prop]);
      if (__getOwnPropSymbols$v)
        for (var prop of __getOwnPropSymbols$v(b)) {
          if (__propIsEnum$v.call(b, prop))
            __defNormalProp$v(a, prop, b[prop]);
        }
      return a;
    };
    var __objRest$o = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$v.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$v)
        for (var prop of __getOwnPropSymbols$v(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$v.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    function onImageErrorHide(event) {
      const target = event.target;
      if (target) {
        target.style.display = "none";
      }
    }
    const AvatarBase = (_a) => {
      var _b = _a, { name, imageSrc } = _b, props = __objRest$o(_b, ["name", "imageSrc"]);
      const initials = getInitials(name);
      return /* @__PURE__ */ themeUi.jsx(AvatarContainer, __spreadValues$v({
        "data-testid": "avatar-container",
        sx: __spreadValues$v({}, avatarThemeStyle),
        title: name
      }, props), imageSrc ? /* @__PURE__ */ themeUi.jsx(AvatarImage, {
        alt: name,
        "data-testid": "avatar-image",
        onError: onImageErrorHide,
        src: imageSrc
      }) : /* @__PURE__ */ themeUi.jsx(AvatarInitials, null, initials));
    };
    const RoundedAvatar = (_c) => {
      var _d = _c, { size = 24 } = _d, props = __objRest$o(_d, ["size"]);
      return /* @__PURE__ */ themeUi.jsx(AvatarBase, __spreadValues$v({
        sx: __spreadValues$v({
          borderRadius: "pill"
        }, RoundedAvatarContansts[Number(size)])
      }, props));
    };
    const SquareAvatar = (_e) => {
      var _f = _e, { size = 24 } = _f, props = __objRest$o(_f, ["size"]);
      return /* @__PURE__ */ themeUi.jsx(AvatarBase, __spreadValues$v({
        sx: __spreadValues$v({
          borderRadius: "small"
        }, SquareAvatarContansts[Number(size)])
      }, props));
    };

    const BottomNavigationContainer = styled__default["default"].div`
    width: 100%;
    box-sizing: border-box;
`;
    const BottomNavigationTabsContainer = styled__default["default"].div`
    overflow: hidden;
    display: flex;
    flex-direction: row;

    > :nth-child(1),
    > :nth-child(3) {
        box-shadow: 0px -1px 7px 0px rgba(54, 77, 148, 0.08);
    }
`;
    const NavigationButtonsActive = styled.css`
    transform: translateY(100%);
    > div {
        box-shadow: none;
    }
`;
    const NavigationButtonsInactive = styled.css``;
    const BottomNavigationContentContainer = styled__default["default"].div`
    background-color: #ffffff;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;
    const BottomNavigationButtonsContainer = styled__default["default"](BottomNavigationContentContainer)`
    overflow: hidden;
    width: 100%;
    transition: 0.3s transform;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    ${({ active = false }) => active ? NavigationButtonsActive : NavigationButtonsInactive}
`;

    const NavigationFabActive = styled.css`
    transform: translateY(100%);
`;
    const NavigationFabInactive = styled.css``;
    const BottomNavigationFab = styled__default["default"](BottomNavigationContentContainer)`
    width: 180px;
    position: relative;
    background: transparent;
    border: none;
    display: flex;
    flex-grow: 1;
    overflow: hidden;
    box-shadow: 0 1px 2px -2px rgba(54, 77, 148, 0.08);
    transition: 0.3s transform;
    ${({ active = false }) => active ? NavigationFabActive : NavigationFabInactive}

    &::before,
    &::after {
        transition: 0.3s transform;
        transform: rotate(180deg);
    }

    &::before {
        content: '';
        position: absolute;
        height: 100%;
        width: 100%;
        top: -40%;
        border-top-left-radius: 100px;
        border-top-right-radius: 100px;
        background-color: transparent;
        box-shadow: inset 0px 1px 7px rgba(54, 77, 148, 0.08);
        display: flex;
    }

    &::after {
        content: '';
        position: absolute;
        height: 100%;
        width: 100%;
        top: -40%;
        border-top-left-radius: 100px;
        border-top-right-radius: 100px;
        background-color: transparent;
        box-shadow: 0px -20px 0px 500px #fff;
        display: flex;
    }
`;

    var __defProp$u = Object.defineProperty;
    var __defProps$f = Object.defineProperties;
    var __getOwnPropDescs$f = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$u = Object.getOwnPropertySymbols;
    var __hasOwnProp$u = Object.prototype.hasOwnProperty;
    var __propIsEnum$u = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$u = (obj, key, value) => key in obj ? __defProp$u(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$u = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$u.call(b, prop))
          __defNormalProp$u(a, prop, b[prop]);
      if (__getOwnPropSymbols$u)
        for (var prop of __getOwnPropSymbols$u(b)) {
          if (__propIsEnum$u.call(b, prop))
            __defNormalProp$u(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$f = (a, b) => __defProps$f(a, __getOwnPropDescs$f(b));
    const buttonBase = ({ borderRadius = "medium", fullWidth, width }) => ({
      width: fullWidth && "100%" || width || "auto",
      borderRadius,
      fontFamily: "normal",
      fontWeight: "bold",
      transition: "all 200ms",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer"
    });
    const disabledBase = {
      cursor: "auto",
      color: "grays.60"
    };
    const buttonsTheme = {
      primary: {
        bg: "brand.primary.40",
        color: "white",
        "&:focus,&:hover": {
          bg: "brand.primary.30"
        },
        "&:active": {
          bg: "brand.primary.20"
        },
        "&:disabled": __spreadProps$f(__spreadValues$u({}, disabledBase), {
          bg: "grays.80"
        })
      },
      secondary: {
        bg: "transparent",
        border: "1px solid",
        borderColor: "brand.primary.40",
        color: "brand.primary.40",
        "&:focus,&:hover,&:active": {
          bg: "interaction.subtle.01"
        },
        "&:disabled": __spreadProps$f(__spreadValues$u({}, disabledBase), {
          color: "grays.70",
          borderColor: "grays.70",
          "&:focus,&:hover,&:active": {
            bg: "transparent"
          }
        })
      },
      tertiary: {
        bg: "transparent",
        color: "brand.primary.40",
        "&:focus,&:hover,&:active": {
          bg: "interaction.subtle.01"
        },
        "&:disabled": __spreadProps$f(__spreadValues$u({}, disabledBase), {
          "&:focus,&:hover,&:active": {
            bg: "transparent"
          }
        })
      }
    };
    const buttonStyleSize = {
      default: {
        py: 4,
        px: 6,
        fontSize: 1,
        height: "3em"
      },
      compact: {
        px: 4,
        py: 3,
        fontSize: "xmedium",
        height: "2.25em"
      }
    };
    const loadingColor = ({ variant }) => {
      switch (variant) {
        case "primary":
          return "white";
        case "tertiary":
          return "brand.primary.40";
        default:
          return "grays.70";
      }
    };

    const getLoadingStyle = ({ size, strokeWidth, color }) => {
      let loadingSize;
      switch (size) {
        case "lg":
          loadingSize = 32;
          break;
        case "md":
          loadingSize = 24;
          break;
        case "sm":
          loadingSize = 16;
          break;
        default:
          loadingSize = size;
          break;
      }
      return {
        "& div": {
          animation: "spin 1s linear infinite",
          borderBottomColor: "inherit",
          borderLeftColor: "transparent",
          borderRadius: "pill",
          borderRightColor: "inherit",
          borderStyle: "solid",
          borderTopColor: "inherit",
          borderWidth: strokeWidth,
          color,
          display: "block",
          height: "100%",
          position: "relative",
          width: "100%"
        },
        "@keyframes spin": {
          "0%": {
            transform: "rotate(0deg)"
          },
          "100%": {
            transform: "rotate(360deg)"
          }
        },
        alignItems: "center",
        display: "flex",
        height: loadingSize,
        justifyContent: "center",
        position: "relative",
        width: loadingSize
      };
    };

    var __defProp$t = Object.defineProperty;
    var __getOwnPropSymbols$t = Object.getOwnPropertySymbols;
    var __hasOwnProp$t = Object.prototype.hasOwnProperty;
    var __propIsEnum$t = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$t = (obj, key, value) => key in obj ? __defProp$t(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$t = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$t.call(b, prop))
          __defNormalProp$t(a, prop, b[prop]);
      if (__getOwnPropSymbols$t)
        for (var prop of __getOwnPropSymbols$t(b)) {
          if (__propIsEnum$t.call(b, prop))
            __defNormalProp$t(a, prop, b[prop]);
        }
      return a;
    };
    var __objRest$n = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$t.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$t)
        for (var prop of __getOwnPropSymbols$t(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$t.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const Loading = React.forwardRef((_a, ref) => {
      var _b = _a, { progress, size = "lg", strokeWidth = 4, text = "", color = "primary", sx } = _b, props = __objRest$n(_b, ["progress", "size", "strokeWidth", "text", "color", "sx"]);
      return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadValues$t({
        "aria-describedby": "id",
        "aria-valuemax": 100,
        "aria-valuemin": 0,
        "aria-valuetext": progress ? progress.toString() : text,
        ref,
        role: "progressbar",
        sx: __spreadValues$t(__spreadValues$t({}, getLoadingStyle({ size, strokeWidth, color })), sx),
        tabIndex: 0
      }, props), /* @__PURE__ */ React__default["default"].createElement(Box, null));
    });

    var __defProp$s = Object.defineProperty;
    var __getOwnPropSymbols$s = Object.getOwnPropertySymbols;
    var __hasOwnProp$s = Object.prototype.hasOwnProperty;
    var __propIsEnum$s = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$s = (obj, key, value) => key in obj ? __defProp$s(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$s = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$s.call(b, prop))
          __defNormalProp$s(a, prop, b[prop]);
      if (__getOwnPropSymbols$s)
        for (var prop of __getOwnPropSymbols$s(b)) {
          if (__propIsEnum$s.call(b, prop))
            __defNormalProp$s(a, prop, b[prop]);
        }
      return a;
    };
    var __objRest$m = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$s.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$s)
        for (var prop of __getOwnPropSymbols$s(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$s.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const Button$1 = (_a) => {
      var _b = _a, {
        size = "default",
        variant = "primary",
        children,
        isLoading,
        sx,
        disabled,
        width
      } = _b, props = __objRest$m(_b, [
        "size",
        "variant",
        "children",
        "isLoading",
        "sx",
        "disabled",
        "width"
      ]);
      return /* @__PURE__ */ themeUi.jsx(themeUi.Button, __spreadValues$s({
        disabled: disabled || isLoading,
        sx: __spreadValues$s(__spreadValues$s(__spreadValues$s(__spreadValues$s({}, buttonBase(__spreadValues$s({ width }, props))), buttonStyleSize[size]), buttonsTheme[variant]), sx)
      }, props), isLoading ? /* @__PURE__ */ themeUi.jsx(Loading, {
        color: loadingColor(__spreadValues$s({ variant }, props)),
        mx: 4,
        size: size === "compact" ? 16 : 24,
        strokeWidth: 4
      }) : children);
    };

    const fabAddIconInactive = styled.css`
    transition: opacity 0.1s, transform 0.1s;
`;
    const fabAddIconActive = styled.css`
    position: absolute;
    transform: rotate(180deg) scale(0.5);
    transition: opacity 0.1s, transform 0.1s;
    opacity: 0;
`;
    const fabCloseIconInactive = styled.css`
    position: absolute;
    transform: rotate(180deg) scale(1);
    opacity: 0;
`;
    const fabCloseIconActive = styled.css`
    transition: opacity 0.1s, transform 0.1s;
    opacity: 1;
`;
    const FabIconContainer = styled__default["default"](Icon)`
    position: relative;

    .close-icon {
        ${({ active = false }) => active ? fabCloseIconActive : fabCloseIconInactive}
    }

    .add-icon {
        ${({ active = false }) => active ? fabAddIconActive : fabAddIconInactive}
    }
`;

    var __defProp$r = Object.defineProperty;
    var __getOwnPropSymbols$r = Object.getOwnPropertySymbols;
    var __hasOwnProp$r = Object.prototype.hasOwnProperty;
    var __propIsEnum$r = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$r = (obj, key, value) => key in obj ? __defProp$r(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$r = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$r.call(b, prop))
          __defNormalProp$r(a, prop, b[prop]);
      if (__getOwnPropSymbols$r)
        for (var prop of __getOwnPropSymbols$r(b)) {
          if (__propIsEnum$r.call(b, prop))
            __defNormalProp$r(a, prop, b[prop]);
        }
      return a;
    };
    var __objRest$l = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$r.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$r)
        for (var prop of __getOwnPropSymbols$r(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$r.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const Fab = (_a) => {
      var _b = _a, { active = false, isLoading = false } = _b, props = __objRest$l(_b, ["active", "isLoading"]);
      return /* @__PURE__ */ React__default["default"].createElement(Button$1, __spreadValues$r({
        sx: {
          borderRadius: "pill",
          p: 1,
          width: "3.5em",
          height: "3.5em"
        }
      }, props), /* @__PURE__ */ React__default["default"].createElement(FabIconContainer, {
        active,
        size: 24
      }, /* @__PURE__ */ React__default["default"].createElement(icons.SystemBoldClose, {
        className: "close-icon"
      }), /* @__PURE__ */ React__default["default"].createElement(icons.SystemBoldAdd, {
        className: "add-icon"
      })));
    };

    const BottomNavigationFabButton = styled__default["default"](Fab)`
    position: absolute;
    bottom: 50%;
    right: 0;
    left: 0;
    margin: auto !important;
`;

    var __defProp$q = Object.defineProperty;
    var __getOwnPropSymbols$q = Object.getOwnPropertySymbols;
    var __hasOwnProp$q = Object.prototype.hasOwnProperty;
    var __propIsEnum$q = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$q = (obj, key, value) => key in obj ? __defProp$q(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$q = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$q.call(b, prop))
          __defNormalProp$q(a, prop, b[prop]);
      if (__getOwnPropSymbols$q)
        for (var prop of __getOwnPropSymbols$q(b)) {
          if (__propIsEnum$q.call(b, prop))
            __defNormalProp$q(a, prop, b[prop]);
        }
      return a;
    };
    const BottomNavigationMenuItemContainer = styled__default["default"].div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    box-sizing: border-box;
`;
    const BottomNavigationMenuItem = ({ UnactiveIcon, ActiveIcon, label, active = false }) => {
      const activeProps = active ? { color: "primary" } : {};
      const RenderedIcon = active && ActiveIcon || UnactiveIcon;
      return /* @__PURE__ */ themeUi.jsx(BottomNavigationMenuItemContainer, {
        sx: __spreadValues$q({ fontSize: 0 }, activeProps)
      }, /* @__PURE__ */ themeUi.jsx(Icon, __spreadValues$q({
        size: "large"
      }, activeProps), /* @__PURE__ */ themeUi.jsx(RenderedIcon, null)), label);
    };

    var __defProp$p = Object.defineProperty;
    var __defProps$e = Object.defineProperties;
    var __getOwnPropDescs$e = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$p = Object.getOwnPropertySymbols;
    var __hasOwnProp$p = Object.prototype.hasOwnProperty;
    var __propIsEnum$p = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$p = (obj, key, value) => key in obj ? __defProp$p(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$p = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$p.call(b, prop))
          __defNormalProp$p(a, prop, b[prop]);
      if (__getOwnPropSymbols$p)
        for (var prop of __getOwnPropSymbols$p(b)) {
          if (__propIsEnum$p.call(b, prop))
            __defNormalProp$p(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$e = (a, b) => __defProps$e(a, __getOwnPropDescs$e(b));
    const dividerBase = {
      height: "1px",
      backgroundColor: "grays.70",
      width: "100%"
    };
    const dividersTheme = {
      horizontal: __spreadValues$p({}, dividerBase),
      vertical: __spreadProps$e(__spreadValues$p({}, dividerBase), {
        transform: "rotate(90deg)"
      })
    };

    var __defProp$o = Object.defineProperty;
    var __defProps$d = Object.defineProperties;
    var __getOwnPropDescs$d = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$o = Object.getOwnPropertySymbols;
    var __hasOwnProp$o = Object.prototype.hasOwnProperty;
    var __propIsEnum$o = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$o = (obj, key, value) => key in obj ? __defProp$o(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$o = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$o.call(b, prop))
          __defNormalProp$o(a, prop, b[prop]);
      if (__getOwnPropSymbols$o)
        for (var prop of __getOwnPropSymbols$o(b)) {
          if (__propIsEnum$o.call(b, prop))
            __defNormalProp$o(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$d = (a, b) => __defProps$d(a, __getOwnPropDescs$d(b));
    var __objRest$k = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$o.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$o)
        for (var prop of __getOwnPropSymbols$o(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$o.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const Divider = React__default["default"].forwardRef((_a, ref) => {
      var _b = _a, { sx, direction = "horizontal" } = _b, props = __objRest$k(_b, ["sx", "direction"]);
      return /* @__PURE__ */ React__default["default"].createElement(themeUi.Divider, __spreadProps$d(__spreadValues$o({
        sx: __spreadValues$o(__spreadValues$o({}, sx), dividersTheme[direction])
      }, props), {
        ref
      }));
    });

    var __defProp$n = Object.defineProperty;
    var __defProps$c = Object.defineProperties;
    var __getOwnPropDescs$c = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$n = Object.getOwnPropertySymbols;
    var __hasOwnProp$n = Object.prototype.hasOwnProperty;
    var __propIsEnum$n = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$n = (obj, key, value) => key in obj ? __defProp$n(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$n = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$n.call(b, prop))
          __defNormalProp$n(a, prop, b[prop]);
      if (__getOwnPropSymbols$n)
        for (var prop of __getOwnPropSymbols$n(b)) {
          if (__propIsEnum$n.call(b, prop))
            __defNormalProp$n(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$c = (a, b) => __defProps$c(a, __getOwnPropDescs$c(b));
    var __objRest$j = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$n.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$n)
        for (var prop of __getOwnPropSymbols$n(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$n.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const Flex = React__default["default"].forwardRef((_a, ref) => {
      var _b = _a, { sx } = _b, props = __objRest$j(_b, ["sx"]);
      return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadProps$c(__spreadValues$n({
        sx: __spreadValues$n({ display: "flex" }, sx)
      }, props), {
        ref
      }));
    });

    var __defProp$m = Object.defineProperty;
    var __getOwnPropSymbols$m = Object.getOwnPropertySymbols;
    var __hasOwnProp$m = Object.prototype.hasOwnProperty;
    var __propIsEnum$m = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$m = (obj, key, value) => key in obj ? __defProp$m(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$m = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$m.call(b, prop))
          __defNormalProp$m(a, prop, b[prop]);
      if (__getOwnPropSymbols$m)
        for (var prop of __getOwnPropSymbols$m(b)) {
          if (__propIsEnum$m.call(b, prop))
            __defNormalProp$m(a, prop, b[prop]);
        }
      return a;
    };
    var __objRest$i = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$m.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$m)
        for (var prop of __getOwnPropSymbols$m(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$m.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const Grid = (_a) => {
      var _b = _a, { sx } = _b, props = __objRest$i(_b, ["sx"]);
      return /* @__PURE__ */ React__default["default"].createElement(themeUi.Grid, __spreadValues$m({
        sx: __spreadValues$m({
          textAlign: "center"
        }, sx)
      }, props));
    };

    const TypoSxStyle = ({ color, align, size, weight, letter, lineHeight }) => ({
      color,
      textAlign: align,
      fontSize: size,
      fontWeight: weight,
      letterSpacing: letter,
      lineHeight
    });

    var __defProp$l = Object.defineProperty;
    var __defProps$b = Object.defineProperties;
    var __getOwnPropDescs$b = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$l = Object.getOwnPropertySymbols;
    var __hasOwnProp$l = Object.prototype.hasOwnProperty;
    var __propIsEnum$l = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$l = (obj, key, value) => key in obj ? __defProp$l(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$l = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$l.call(b, prop))
          __defNormalProp$l(a, prop, b[prop]);
      if (__getOwnPropSymbols$l)
        for (var prop of __getOwnPropSymbols$l(b)) {
          if (__propIsEnum$l.call(b, prop))
            __defNormalProp$l(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$b = (a, b) => __defProps$b(a, __getOwnPropDescs$b(b));
    var __objRest$h = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$l.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$l)
        for (var prop of __getOwnPropSymbols$l(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$l.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const Typography = (_a) => {
      var _b = _a, { as = "span", sx, role, children } = _b, props = __objRest$h(_b, ["as", "sx", "role", "children"]);
      return /* @__PURE__ */ React__default["default"].createElement(themeUi.Text, __spreadProps$b(__spreadValues$l({
        as,
        sx: __spreadValues$l(__spreadValues$l({}, TypoSxStyle(props)), sx)
      }, props), {
        ref: null
      }), children || role);
    };

    var __defProp$k = Object.defineProperty;
    var __defProps$a = Object.defineProperties;
    var __getOwnPropDescs$a = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$k = Object.getOwnPropertySymbols;
    var __hasOwnProp$k = Object.prototype.hasOwnProperty;
    var __propIsEnum$k = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$k = (obj, key, value) => key in obj ? __defProp$k(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$k = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$k.call(b, prop))
          __defNormalProp$k(a, prop, b[prop]);
      if (__getOwnPropSymbols$k)
        for (var prop of __getOwnPropSymbols$k(b)) {
          if (__propIsEnum$k.call(b, prop))
            __defNormalProp$k(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$a = (a, b) => __defProps$a(a, __getOwnPropDescs$a(b));
    var __objRest$g = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$k.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$k)
        for (var prop of __getOwnPropSymbols$k(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$k.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const getLeadingIconCommonStyle = (leadingIcon) => ({
      pl: leadingIcon ? 12 : 3
    });
    const StyledContainer = (_a) => {
      var _b = _a, { children } = _b, props = __objRest$g(_b, ["children"]);
      return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadValues$k({
        sx: {
          position: "relative",
          height: "56px"
        }
      }, props), children);
    };
    const activeLabelStyle = {
      fontSize: 0,
      overflow: "hidden",
      pt: 0,
      bg: "white",
      width: "auto",
      px: 1,
      ml: 3,
      pl: 1,
      transform: "translateY(-0.625rem)"
    };
    const StyledLabel = React__default["default"].forwardRef((_c, ref) => {
      var _d = _c, { color, isActive, label, variant, leadingIcon } = _d, props = __objRest$g(_d, ["color", "isActive", "label", "variant", "leadingIcon"]);
      const activeStyle = isActive ? activeLabelStyle : "";
      return /* @__PURE__ */ React__default["default"].createElement(themeUi.Label, __spreadValues$k({
        color,
        ref,
        sx: __spreadProps$a(__spreadValues$k(__spreadValues$k({
          px: 1,
          pt: 4,
          transition: "all 200ms",
          position: "absolute"
        }, getLeadingIconCommonStyle(!!leadingIcon)), activeStyle), {
          pointerEvents: "none"
        })
      }, props), label);
    });
    const StyledInput = React__default["default"].forwardRef((_e, ref) => {
      var _f = _e, { name, color, leadingIcon } = _f, props = __objRest$g(_f, ["name", "color", "leadingIcon"]);
      return /* @__PURE__ */ React__default["default"].createElement(themeUi.Input, __spreadValues$k({
        name,
        ref,
        sx: __spreadProps$a(__spreadValues$k({
          height: "56px",
          pr: leadingIcon ? 3 : 12,
          borderColor: `${color}`,
          border: `1px solid ${color}`,
          fontFamily: "normal"
        }, getLeadingIconCommonStyle(!!leadingIcon)), {
          "&:focus": __spreadValues$k({
            borderColor: `${color}`,
            border: `1px solid ${color}`,
            outline: "none"
          }, getLeadingIconCommonStyle(!!leadingIcon)),
          '&[type="password"]': {
            font: "small-caption",
            fontSize: 3
          }
        })
      }, props));
    });
    const StyledHelperText = ({ children, color }) => /* @__PURE__ */ React__default["default"].createElement(Typography, {
      m: 0,
      ml: 2,
      mt: 1,
      sx: {
        display: "flex",
        flexWrap: "wrap",
        whiteSpace: "nowrap",
        "& > *": {
          mx: 2,
          fontSize: 0
        },
        color
      }
    }, children);
    const StyledIcon = (_g) => {
      var _h = _g, { children, color, direction = "left" } = _h, props = __objRest$g(_h, ["children", "color", "direction"]);
      return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadValues$k({
        sx: {
          position: "absolute",
          [direction]: 2,
          top: 3,
          mx: 1,
          pointerEvents: direction === "left" ? "none" : "auto"
        }
      }, props), children);
    };

    var __defProp$j = Object.defineProperty;
    var __getOwnPropSymbols$j = Object.getOwnPropertySymbols;
    var __hasOwnProp$j = Object.prototype.hasOwnProperty;
    var __propIsEnum$j = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$j = (obj, key, value) => key in obj ? __defProp$j(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$j = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$j.call(b, prop))
          __defNormalProp$j(a, prop, b[prop]);
      if (__getOwnPropSymbols$j)
        for (var prop of __getOwnPropSymbols$j(b)) {
          if (__propIsEnum$j.call(b, prop))
            __defNormalProp$j(a, prop, b[prop]);
        }
      return a;
    };
    const getIconArgs = (hasLeadingIcon, color) => ({
      color: hasLeadingIcon ? "grays.50" : color,
      size: 23
    });
    const TextFieldIcon = ({ variant, leadingIcon, trailingIcon, color }) => /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, variant !== "default" && !trailingIcon && /* @__PURE__ */ React__default["default"].createElement(StyledIcon, {
      direction: "right"
    }, /* @__PURE__ */ React__default["default"].createElement(Icon, __spreadValues$j({}, getIconArgs(!!leadingIcon, color)), variant === "success" ? /* @__PURE__ */ React__default["default"].createElement(icons.SystemBoldRoundcheckon, null) : /* @__PURE__ */ React__default["default"].createElement(icons.SystemBoldWarning, null))), (leadingIcon || trailingIcon) && /* @__PURE__ */ React__default["default"].createElement(StyledIcon, {
      direction: trailingIcon ? "right" : "left"
    }, /* @__PURE__ */ React__default["default"].createElement(Icon, __spreadValues$j({}, getIconArgs(!!leadingIcon, color)), trailingIcon || leadingIcon)));

    function _isPlaceholder(a) {
      return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
    }

    /**
     * Optimized internal one-arity curry function.
     *
     * @private
     * @category Function
     * @param {Function} fn The function to curry.
     * @return {Function} The curried function.
     */

    function _curry1(fn) {
      return function f1(a) {
        if (arguments.length === 0 || _isPlaceholder(a)) {
          return f1;
        } else {
          return fn.apply(this, arguments);
        }
      };
    }

    /**
     * Optimized internal two-arity curry function.
     *
     * @private
     * @category Function
     * @param {Function} fn The function to curry.
     * @return {Function} The curried function.
     */

    function _curry2(fn) {
      return function f2(a, b) {
        switch (arguments.length) {
          case 0:
            return f2;

          case 1:
            return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
              return fn(a, _b);
            });

          default:
            return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
              return fn(_a, b);
            }) : _isPlaceholder(b) ? _curry1(function (_b) {
              return fn(a, _b);
            }) : fn(a, b);
        }
      };
    }

    function _arity(n, fn) {
      /* eslint-disable no-unused-vars */
      switch (n) {
        case 0:
          return function () {
            return fn.apply(this, arguments);
          };

        case 1:
          return function (a0) {
            return fn.apply(this, arguments);
          };

        case 2:
          return function (a0, a1) {
            return fn.apply(this, arguments);
          };

        case 3:
          return function (a0, a1, a2) {
            return fn.apply(this, arguments);
          };

        case 4:
          return function (a0, a1, a2, a3) {
            return fn.apply(this, arguments);
          };

        case 5:
          return function (a0, a1, a2, a3, a4) {
            return fn.apply(this, arguments);
          };

        case 6:
          return function (a0, a1, a2, a3, a4, a5) {
            return fn.apply(this, arguments);
          };

        case 7:
          return function (a0, a1, a2, a3, a4, a5, a6) {
            return fn.apply(this, arguments);
          };

        case 8:
          return function (a0, a1, a2, a3, a4, a5, a6, a7) {
            return fn.apply(this, arguments);
          };

        case 9:
          return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
            return fn.apply(this, arguments);
          };

        case 10:
          return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
            return fn.apply(this, arguments);
          };

        default:
          throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
      }
    }

    /**
     * Optimized internal three-arity curry function.
     *
     * @private
     * @category Function
     * @param {Function} fn The function to curry.
     * @return {Function} The curried function.
     */

    function _curry3(fn) {
      return function f3(a, b, c) {
        switch (arguments.length) {
          case 0:
            return f3;

          case 1:
            return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
              return fn(a, _b, _c);
            });

          case 2:
            return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
              return fn(_a, b, _c);
            }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
              return fn(a, _b, _c);
            }) : _curry1(function (_c) {
              return fn(a, b, _c);
            });

          default:
            return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
              return fn(_a, _b, c);
            }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
              return fn(_a, b, _c);
            }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
              return fn(a, _b, _c);
            }) : _isPlaceholder(a) ? _curry1(function (_a) {
              return fn(_a, b, c);
            }) : _isPlaceholder(b) ? _curry1(function (_b) {
              return fn(a, _b, c);
            }) : _isPlaceholder(c) ? _curry1(function (_c) {
              return fn(a, b, _c);
            }) : fn(a, b, c);
        }
      };
    }

    /**
     * Tests whether or not an object is an array.
     *
     * @private
     * @param {*} val The object to test.
     * @return {Boolean} `true` if `val` is an array, `false` otherwise.
     * @example
     *
     *      _isArray([]); //=> true
     *      _isArray(null); //=> false
     *      _isArray({}); //=> false
     */
    var _isArray = Array.isArray || function _isArray(val) {
      return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
    };

    function _isString(x) {
      return Object.prototype.toString.call(x) === '[object String]';
    }

    /**
     * Tests whether or not an object is similar to an array.
     *
     * @private
     * @category Type
     * @category List
     * @sig * -> Boolean
     * @param {*} x The object to test.
     * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
     * @example
     *
     *      _isArrayLike([]); //=> true
     *      _isArrayLike(true); //=> false
     *      _isArrayLike({}); //=> false
     *      _isArrayLike({length: 10}); //=> false
     *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
     */

    var _isArrayLike =
    /*#__PURE__*/
    _curry1(function isArrayLike(x) {
      if (_isArray(x)) {
        return true;
      }

      if (!x) {
        return false;
      }

      if (typeof x !== 'object') {
        return false;
      }

      if (_isString(x)) {
        return false;
      }

      if (x.nodeType === 1) {
        return !!x.length;
      }

      if (x.length === 0) {
        return true;
      }

      if (x.length > 0) {
        return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
      }

      return false;
    });

    var _isArrayLike$1 = _isArrayLike;

    var XWrap =
    /*#__PURE__*/
    function () {
      function XWrap(fn) {
        this.f = fn;
      }

      XWrap.prototype['@@transducer/init'] = function () {
        throw new Error('init not implemented on XWrap');
      };

      XWrap.prototype['@@transducer/result'] = function (acc) {
        return acc;
      };

      XWrap.prototype['@@transducer/step'] = function (acc, x) {
        return this.f(acc, x);
      };

      return XWrap;
    }();

    function _xwrap(fn) {
      return new XWrap(fn);
    }

    /**
     * Creates a function that is bound to a context.
     * Note: `R.bind` does not provide the additional argument-binding capabilities of
     * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
     *
     * @func
     * @memberOf R
     * @since v0.6.0
     * @category Function
     * @category Object
     * @sig (* -> *) -> {*} -> (* -> *)
     * @param {Function} fn The function to bind to context
     * @param {Object} thisObj The context to bind `fn` to
     * @return {Function} A function that will execute in the context of `thisObj`.
     * @see R.partial
     * @example
     *
     *      const log = R.bind(console.log, console);
     *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
     *      // logs {a: 2}
     * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
     */

    var bind =
    /*#__PURE__*/
    _curry2(function bind(fn, thisObj) {
      return _arity(fn.length, function () {
        return fn.apply(thisObj, arguments);
      });
    });

    var bind$1 = bind;

    function _arrayReduce(xf, acc, list) {
      var idx = 0;
      var len = list.length;

      while (idx < len) {
        acc = xf['@@transducer/step'](acc, list[idx]);

        if (acc && acc['@@transducer/reduced']) {
          acc = acc['@@transducer/value'];
          break;
        }

        idx += 1;
      }

      return xf['@@transducer/result'](acc);
    }

    function _iterableReduce(xf, acc, iter) {
      var step = iter.next();

      while (!step.done) {
        acc = xf['@@transducer/step'](acc, step.value);

        if (acc && acc['@@transducer/reduced']) {
          acc = acc['@@transducer/value'];
          break;
        }

        step = iter.next();
      }

      return xf['@@transducer/result'](acc);
    }

    function _methodReduce(xf, acc, obj, methodName) {
      return xf['@@transducer/result'](obj[methodName](bind$1(xf['@@transducer/step'], xf), acc));
    }

    var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
    function _reduce(fn, acc, list) {
      if (typeof fn === 'function') {
        fn = _xwrap(fn);
      }

      if (_isArrayLike$1(list)) {
        return _arrayReduce(fn, acc, list);
      }

      if (typeof list['fantasy-land/reduce'] === 'function') {
        return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
      }

      if (list[symIterator] != null) {
        return _iterableReduce(fn, acc, list[symIterator]());
      }

      if (typeof list.next === 'function') {
        return _iterableReduce(fn, acc, list);
      }

      if (typeof list.reduce === 'function') {
        return _methodReduce(fn, acc, list, 'reduce');
      }

      throw new TypeError('reduce: list must be array or iterable');
    }

    /**
     * Returns a single item by iterating through the list, successively calling
     * the iterator function and passing it an accumulator value and the current
     * value from the array, and then passing the result to the next call.
     *
     * The iterator function receives two values: *(acc, value)*. It may use
     * [`R.reduced`](#reduced) to shortcut the iteration.
     *
     * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
     * is *(value, acc)*.
     *
     * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
     * arrays), unlike the native `Array.prototype.reduce` method. For more details
     * on this behavior, see:
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
     *
     * Dispatches to the `reduce` method of the third argument, if present. When
     * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
     * shortcuting, as this is not implemented by `reduce`.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category List
     * @sig ((a, b) -> a) -> a -> [b] -> a
     * @param {Function} fn The iterator function. Receives two values, the accumulator and the
     *        current element from the array.
     * @param {*} acc The accumulator value.
     * @param {Array} list The list to iterate over.
     * @return {*} The final, accumulated value.
     * @see R.reduced, R.addIndex, R.reduceRight
     * @example
     *
     *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
     *      //          -               -10
     *      //         / \              / \
     *      //        -   4           -6   4
     *      //       / \              / \
     *      //      -   3   ==>     -3   3
     *      //     / \              / \
     *      //    -   2           -1   2
     *      //   / \              / \
     *      //  0   1            0   1
     *
     * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
     */

    var reduce =
    /*#__PURE__*/
    _curry3(_reduce);

    var reduce$1 = reduce;

    function _pipe(f, g) {
      return function () {
        return g.call(this, f.apply(this, arguments));
      };
    }

    /**
     * This checks whether a function has a [methodname] function. If it isn't an
     * array it will execute that function otherwise it will default to the ramda
     * implementation.
     *
     * @private
     * @param {Function} fn ramda implemtation
     * @param {String} methodname property to check for a custom implementation
     * @return {Object} Whatever the return value of the method is.
     */

    function _checkForMethod(methodname, fn) {
      return function () {
        var length = arguments.length;

        if (length === 0) {
          return fn();
        }

        var obj = arguments[length - 1];
        return _isArray(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
      };
    }

    /**
     * Returns the elements of the given list or string (or object with a `slice`
     * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
     *
     * Dispatches to the `slice` method of the third argument, if present.
     *
     * @func
     * @memberOf R
     * @since v0.1.4
     * @category List
     * @sig Number -> Number -> [a] -> [a]
     * @sig Number -> Number -> String -> String
     * @param {Number} fromIndex The start index (inclusive).
     * @param {Number} toIndex The end index (exclusive).
     * @param {*} list
     * @return {*}
     * @example
     *
     *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
     *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
     *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
     *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
     *      R.slice(0, 3, 'ramda');                     //=> 'ram'
     */

    var slice =
    /*#__PURE__*/
    _curry3(
    /*#__PURE__*/
    _checkForMethod('slice', function slice(fromIndex, toIndex, list) {
      return Array.prototype.slice.call(list, fromIndex, toIndex);
    }));

    var slice$1 = slice;

    /**
     * Returns all but the first element of the given list or string (or object
     * with a `tail` method).
     *
     * Dispatches to the `slice` method of the first argument, if present.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category List
     * @sig [a] -> [a]
     * @sig String -> String
     * @param {*} list
     * @return {*}
     * @see R.head, R.init, R.last
     * @example
     *
     *      R.tail([1, 2, 3]);  //=> [2, 3]
     *      R.tail([1, 2]);     //=> [2]
     *      R.tail([1]);        //=> []
     *      R.tail([]);         //=> []
     *
     *      R.tail('abc');  //=> 'bc'
     *      R.tail('ab');   //=> 'b'
     *      R.tail('a');    //=> ''
     *      R.tail('');     //=> ''
     */

    var tail =
    /*#__PURE__*/
    _curry1(
    /*#__PURE__*/
    _checkForMethod('tail',
    /*#__PURE__*/
    slice$1(1, Infinity)));

    var tail$1 = tail;

    /**
     * Performs left-to-right function composition. The first argument may have
     * any arity; the remaining arguments must be unary.
     *
     * In some libraries this function is named `sequence`.
     *
     * **Note:** The result of pipe is not automatically curried.
     *
     * @func
     * @memberOf R
     * @since v0.1.0
     * @category Function
     * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
     * @param {...Function} functions
     * @return {Function}
     * @see R.compose
     * @example
     *
     *      const f = R.pipe(Math.pow, R.negate, R.inc);
     *
     *      f(3, 4); // -(3^4) + 1
     * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
     */

    function pipe() {
      if (arguments.length === 0) {
        throw new Error('pipe requires at least one argument');
      }

      return _arity(arguments[0].length, reduce$1(_pipe, arguments[0], tail$1(arguments)));
    }

    var __defProp$i = Object.defineProperty;
    var __defProps$9 = Object.defineProperties;
    var __getOwnPropDescs$9 = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$i = Object.getOwnPropertySymbols;
    var __hasOwnProp$i = Object.prototype.hasOwnProperty;
    var __propIsEnum$i = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$i = (obj, key, value) => key in obj ? __defProp$i(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$i = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$i.call(b, prop))
          __defNormalProp$i(a, prop, b[prop]);
      if (__getOwnPropSymbols$i)
        for (var prop of __getOwnPropSymbols$i(b)) {
          if (__propIsEnum$i.call(b, prop))
            __defNormalProp$i(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$9 = (a, b) => __defProps$9(a, __getOwnPropDescs$9(b));
    var __objRest$f = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$i.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$i)
        for (var prop of __getOwnPropSymbols$i(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$i.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const TextFieldHelpers = (props) => {
      const { helperText, color } = props;
      if (!helperText) {
        return null;
      }
      if (typeof helperText === "string") {
        return /* @__PURE__ */ React__default["default"].createElement(StyledHelperText, {
          color
        }, /* @__PURE__ */ React__default["default"].createElement("span", null, helperText));
      }
      return /* @__PURE__ */ React__default["default"].createElement(StyledHelperText, {
        color
      }, helperText.map((text, i) => /* @__PURE__ */ React__default["default"].createElement("span", {
        key: i
      }, text)));
    };
    const TextField = React__default["default"].forwardRef((props, ref) => {
      const _a = props, {
        children,
        label,
        name,
        value,
        helperText,
        variant = "default",
        leadingIcon,
        trailingIcon,
        defaultValue,
        onBlur,
        onFocus,
        placeholder,
        id,
        disabled,
        onChange
      } = _a, other = __objRest$f(_a, [
        "children",
        "label",
        "name",
        "value",
        "helperText",
        "variant",
        "leadingIcon",
        "trailingIcon",
        "defaultValue",
        "onBlur",
        "onFocus",
        "placeholder",
        "id",
        "disabled",
        "onChange"
      ]);
      const [active, setActive] = React.useState(false);
      const [controlValue, setControlValue] = React.useState(value);
      const previousValueRef = React.useRef(controlValue);
      React.useEffect(() => {
        if (defaultValue) {
          setControlValue(defaultValue);
        } else if (previousValueRef.current !== value) {
          setControlValue(value);
          previousValueRef.current = value;
        }
      }, [value, defaultValue]);
      const hasValue = controlValue || controlValue && defaultValue;
      const isActiveLabel = active || !!hasValue || !!placeholder;
      const activeColor = active && "primary";
      const variantColor = variant !== "default" && variant;
      const colorField = variantColor || activeColor || "grays.60";
      const handleChange = (e) => {
        setControlValue(e.target.value);
        if (onChange) {
          onChange(e);
        }
        e.preventDefault();
      };
      return /* @__PURE__ */ React__default["default"].createElement(StyledContainer, __spreadValues$i({}, other), /* @__PURE__ */ React__default["default"].createElement(StyledLabel, {
        color: colorField,
        htmlFor: id,
        isActive: isActiveLabel,
        label,
        leadingIcon,
        variant
      }), /* @__PURE__ */ React__default["default"].createElement(StyledInput, __spreadProps$9(__spreadValues$i({
        "aria-disabled": disabled,
        "aria-invalid": variant === "error",
        "aria-placeholder": placeholder,
        "aria-readonly": "true",
        autoCapitalize: "none",
        autoComplete: "off",
        color: colorField,
        id,
        role: "textbox",
        type: "text",
        value: controlValue || "",
        variant
      }, props), {
        name,
        onBlur: (e) => pipe(() => setActive(false), () => onBlur && onBlur(e))(),
        onChange: handleChange,
        onFocus: (e) => pipe(() => setActive(true), () => onFocus && onFocus(e))(),
        ref
      })), /* @__PURE__ */ React__default["default"].createElement(TextFieldIcon, {
        color: colorField,
        leadingIcon,
        trailingIcon,
        variant
      }), /* @__PURE__ */ React__default["default"].createElement(TextFieldHelpers, {
        color: colorField,
        helperText
      }));
    });

    var __defProp$h = Object.defineProperty;
    var __getOwnPropSymbols$h = Object.getOwnPropertySymbols;
    var __hasOwnProp$h = Object.prototype.hasOwnProperty;
    var __propIsEnum$h = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$h = (obj, key, value) => key in obj ? __defProp$h(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$h = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$h.call(b, prop))
          __defNormalProp$h(a, prop, b[prop]);
      if (__getOwnPropSymbols$h)
        for (var prop of __getOwnPropSymbols$h(b)) {
          if (__propIsEnum$h.call(b, prop))
            __defNormalProp$h(a, prop, b[prop]);
        }
      return a;
    };
    var __objRest$e = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$h.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$h)
        for (var prop of __getOwnPropSymbols$h(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$h.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const CheckBox = React__namespace.forwardRef((_a, ref) => {
      var _b = _a, { label, name, value } = _b, props = __objRest$e(_b, ["label", "name", "value"]);
      const { disabled } = props;
      const checkBoxSxStyle = (isDisabled = false) => ({
        color: isDisabled ? "grays.70" : "grays.10",
        alignItems: "center",
        input: {
          "~ svg": {
            color: "primary"
          }
        },
        "input:disabled": {
          "~ svg": {
            color: "grays.70"
          }
        },
        "input:focus": {
          "~ svg": {
            bg: "transparent"
          }
        }
      });
      return /* @__PURE__ */ React__namespace.createElement(themeUi.Label, {
        sx: __spreadValues$h({}, checkBoxSxStyle(disabled))
      }, /* @__PURE__ */ React__namespace.createElement(themeUi.Checkbox, __spreadValues$h({
        disabled,
        name,
        ref,
        value
      }, props)), label);
    });

    var __defProp$g = Object.defineProperty;
    var __defProps$8 = Object.defineProperties;
    var __getOwnPropDescs$8 = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$g = Object.getOwnPropertySymbols;
    var __hasOwnProp$g = Object.prototype.hasOwnProperty;
    var __propIsEnum$g = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$g = (obj, key, value) => key in obj ? __defProp$g(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$g = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$g.call(b, prop))
          __defNormalProp$g(a, prop, b[prop]);
      if (__getOwnPropSymbols$g)
        for (var prop of __getOwnPropSymbols$g(b)) {
          if (__propIsEnum$g.call(b, prop))
            __defNormalProp$g(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$8 = (a, b) => __defProps$8(a, __getOwnPropDescs$8(b));
    const cardBase = {
      borderRadius: "small",
      display: "flex"
    };
    const cardsTheme = {
      default: __spreadProps$8(__spreadValues$g({}, cardBase), {
        border: "1px solid",
        borderColor: "grays.80",
        bg: "white",
        color: "black"
      }),
      active: __spreadProps$8(__spreadValues$g({}, cardBase), {
        bg: "primary",
        color: "white"
      })
    };
    const cardStyleSpacing = {
      default: {
        p: 4
      },
      compact: {
        p: 2
      }
    };

    var __defProp$f = Object.defineProperty;
    var __defProps$7 = Object.defineProperties;
    var __getOwnPropDescs$7 = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$f = Object.getOwnPropertySymbols;
    var __hasOwnProp$f = Object.prototype.hasOwnProperty;
    var __propIsEnum$f = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$f = (obj, key, value) => key in obj ? __defProp$f(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$f = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$f.call(b, prop))
          __defNormalProp$f(a, prop, b[prop]);
      if (__getOwnPropSymbols$f)
        for (var prop of __getOwnPropSymbols$f(b)) {
          if (__propIsEnum$f.call(b, prop))
            __defNormalProp$f(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$7 = (a, b) => __defProps$7(a, __getOwnPropDescs$7(b));
    var __objRest$d = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$f.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$f)
        for (var prop of __getOwnPropSymbols$f(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$f.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const Card$1 = (_a) => {
      var _b = _a, { spacing = "default", variant = "default", sx, colorIcon, trailingIcon, children } = _b, props = __objRest$d(_b, ["spacing", "variant", "sx", "colorIcon", "trailingIcon", "children"]);
      const cardRef = React.useRef(null);
      return /* @__PURE__ */ React__default["default"].createElement(themeUi.Card, __spreadProps$7(__spreadValues$f({}, props), {
        ref: cardRef,
        sx: __spreadValues$f(__spreadValues$f(__spreadValues$f({}, cardStyleSpacing[spacing]), cardsTheme[variant]), sx)
      }), children, trailingIcon && /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, /* @__PURE__ */ React__default["default"].createElement(Box, {
        mx: "auto",
        p: 0,
        pl: 4
      }), /* @__PURE__ */ React__default["default"].createElement(Icon, {
        color: colorIcon || "grays.70",
        size: 4
      }, trailingIcon)));
    };

    const WrapperBox = styled__default["default"](Box)`
    width: 100%;
    box-sizing: border-box;
    display: flex;
    padding: 0;
    margin: 0;
    align-items: center;
`;
    const CardInfoBox = styled__default["default"](Box)`
    width: 100%;
    flex: 1 1 auto;
    box-sizing: border-box;
`;
    const UserNameHeading = styled__default["default"].h5`
    width: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-style: normal;
    line-height: 24px;
    letter-spacing: 0.4px;
    text-transform: capitalize;
`;
    styled__default["default"].p`
    width: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-style: normal;
    line-height: 16px;
    letter-spacing: 0.2px;
    text-transform: capitalize;
`;
    const Card = styled__default["default"](Card$1)`
    width: 100%;
    &:hover {
        cursor: ${({ onClick }) => onClick ? "pointer" : "default"};
    }
`;

    var __defProp$e = Object.defineProperty;
    var __defProps$6 = Object.defineProperties;
    var __getOwnPropDescs$6 = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$e = Object.getOwnPropertySymbols;
    var __hasOwnProp$e = Object.prototype.hasOwnProperty;
    var __propIsEnum$e = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$e = (obj, key, value) => key in obj ? __defProp$e(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$e = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$e.call(b, prop))
          __defNormalProp$e(a, prop, b[prop]);
      if (__getOwnPropSymbols$e)
        for (var prop of __getOwnPropSymbols$e(b)) {
          if (__propIsEnum$e.call(b, prop))
            __defNormalProp$e(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$6 = (a, b) => __defProps$6(a, __getOwnPropDescs$6(b));
    var __objRest$c = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$e.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$e)
        for (var prop of __getOwnPropSymbols$e(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$e.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const avatarProps = ({ imageSrc, name, avatarSize }) => ({
      imageSrc,
      m: 2,
      size: avatarSize,
      name,
      sx: {
        color: "grays.40",
        backgroundColor: "grays.100",
        flex: `0 0 ${avatarSize}px`
      }
    });
    const AvatarCard = (_a) => {
      var _b = _a, {
        name,
        label,
        imageSrc,
        avatarType = "square",
        avatarInitials,
        subtitle,
        onClick
      } = _b, rest = __objRest$c(_b, [
        "name",
        "label",
        "imageSrc",
        "avatarType",
        "avatarInitials",
        "subtitle",
        "onClick"
      ]);
      const isBigAvatar = name && label && subtitle;
      const avatarSize = isBigAvatar ? 56 : 40;
      const avatarSourceInitials = avatarInitials ? avatarInitials : name;
      const avatarCommonProps = avatarProps({ imageSrc, avatarSize, name: avatarSourceInitials });
      return /* @__PURE__ */ themeUi.jsx(Card, __spreadProps$6(__spreadValues$e({}, rest), {
        onClick,
        sx: {
          padding: 2,
          borderStyle: "solid",
          borderWidth: 1,
          borderColor: "grays.80",
          backgroundColor: "white",
          borderRadius: 4
        }
      }), /* @__PURE__ */ themeUi.jsx(WrapperBox, null, avatarType === "rounded" ? /* @__PURE__ */ themeUi.jsx(RoundedAvatar, __spreadValues$e({
        "data-testid": "avatar-card"
      }, avatarCommonProps)) : /* @__PURE__ */ themeUi.jsx(SquareAvatar, __spreadValues$e({
        "data-testid": "avatar-card"
      }, avatarCommonProps)), /* @__PURE__ */ themeUi.jsx(CardInfoBox, {
        m: 2
      }, name && /* @__PURE__ */ themeUi.jsx(UserNameHeading, {
        sx: {
          fontSize: "medium",
          fontWeight: 600
        }
      }, name.toLowerCase()), subtitle && /* @__PURE__ */ themeUi.jsx(Typography, {
        as: "p",
        mb: 1,
        size: "xmedium"
      }, subtitle), label && /* @__PURE__ */ themeUi.jsx(Typography, {
        as: "p",
        color: "grays.40",
        size: "small"
      }, label))));
    };

    var __defProp$d = Object.defineProperty;
    var __getOwnPropSymbols$d = Object.getOwnPropertySymbols;
    var __hasOwnProp$d = Object.prototype.hasOwnProperty;
    var __propIsEnum$d = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$d = (obj, key, value) => key in obj ? __defProp$d(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$d = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$d.call(b, prop))
          __defNormalProp$d(a, prop, b[prop]);
      if (__getOwnPropSymbols$d)
        for (var prop of __getOwnPropSymbols$d(b)) {
          if (__propIsEnum$d.call(b, prop))
            __defNormalProp$d(a, prop, b[prop]);
        }
      return a;
    };
    var __objRest$b = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$d.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$d)
        for (var prop of __getOwnPropSymbols$d(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$d.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const UserCard = (_a) => {
      var _b = _a, { label = "voc\xEA" } = _b, props = __objRest$b(_b, ["label"]);
      return /* @__PURE__ */ React__default["default"].createElement(AvatarCard, __spreadValues$d({
        avatarType: "rounded",
        "data-testid": "user-card-avatar",
        label
      }, props));
    };

    const CardContainer = styled__default["default"].div`
    width: 100%;
    cursor: pointer;
`;
    const CardBody = styled__default["default"].div`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    font-size: 1em;
`;
    const CardFooter = styled__default["default"].div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
    const SideBarIcon = styled__default["default"].div`
    margin-right: 1.25em;
    display: flex;
    align-items: center;
    @media (min-width: 48em) {
        justify-content: center;
    }
`;
    const DetailsConsult = styled__default["default"].div`
    display: flex;
    flex-direction: column;
`;
    const StyledHeadline = styled__default["default"](Box)`
    font-style: normal;
    font-weight: ${(props) => props.active ? 500 : 600};
    font-size: 1em;
    line-height: ${(props) => props.active ? 1.25 : 1.5};
    margin: 0;
`;
    const Button = styled__default["default"].button`
    margin: ${theme.space[0]};
    padding: ${theme.space[0]};
    border: ${theme.space[0]};
    outline: none;
    cursor: pointer;
    font-size: 0.875em;
    color: ${theme.colors.white};
    background-color: transparent;
    text-decoration: underline;
    font-family: ${({ theme }) => theme.fonts.normal};
`;
    const StatusLabel = styled__default["default"].span`
    color: ${(props) => props.active ? theme.colors.blues[100] : theme.colors.black};
    font-style: italic;
    font-weight: normal;
    font-size: 0.75em;
    line-height: 1.33;
    display: flex;
    align-items: center;
    letter-spacing: 0.016em;
    margin-bottom: 1.5em;
`;
    const StyledSubtitle = styled__default["default"].span`
    color: ${(props) => props.active ? theme.colors.blues[100] : theme.colors.grays[40]};
    font-style: normal;
    font-weight: normal;
    font-size: 0.75em;
    line-height: 1.33;
    letter-spacing: 0.016em;
`;
    const DateCaption = styled__default["default"].span`
    color: ${(props) => props.active ? theme.colors.blues[100] : theme.colors.grays[40]};
    font-style: normal;
    font-weight: 600;
    font-size: 0.625em;
    line-height: 1.2;
    letter-spacing: 0.072em;
    text-transform: uppercase;
    margin-bottom: 0.8em;
`;

    var __defProp$c = Object.defineProperty;
    var __getOwnPropSymbols$c = Object.getOwnPropertySymbols;
    var __hasOwnProp$c = Object.prototype.hasOwnProperty;
    var __propIsEnum$c = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$c = (obj, key, value) => key in obj ? __defProp$c(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$c = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$c.call(b, prop))
          __defNormalProp$c(a, prop, b[prop]);
      if (__getOwnPropSymbols$c)
        for (var prop of __getOwnPropSymbols$c(b)) {
          if (__propIsEnum$c.call(b, prop))
            __defNormalProp$c(a, prop, b[prop]);
        }
      return a;
    };
    var __objRest$a = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$c.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$c)
        for (var prop of __getOwnPropSymbols$c(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$c.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const EventCard = (_a) => {
      var _b = _a, { onClick, subtitle, subtitleAriaLabel, leadingIcon, isActive } = _b, props = __objRest$a(_b, ["onClick", "subtitle", "subtitleAriaLabel", "leadingIcon", "isActive"]);
      return /* @__PURE__ */ React__default["default"].createElement(CardContainer, {
        onClick
      }, /* @__PURE__ */ React__default["default"].createElement(Card$1, __spreadValues$c({
        sx: { minHeight: 136 },
        variant: isActive ? "active" : "default"
      }, props), /* @__PURE__ */ React__default["default"].createElement(CardBody, null, /* @__PURE__ */ React__default["default"].createElement(SideBarIcon, null, /* @__PURE__ */ React__default["default"].createElement(Icon, {
        color: isActive ? theme.colors.white : theme.colors.oranges[50],
        size: 24
      }, leadingIcon || /* @__PURE__ */ React__default["default"].createElement(icons.ServicesBoldTelemedicine, null))), /* @__PURE__ */ React__default["default"].createElement("div", {
        style: { display: "flex", flexDirection: "column", height: "100%", width: "100%" }
      }, renderDetailsComp(__spreadValues$c({ isActive }, props)), /* @__PURE__ */ React__default["default"].createElement(CardFooter, null, /* @__PURE__ */ React__default["default"].createElement(StyledSubtitle, {
        active: isActive,
        "aria-label": subtitleAriaLabel
      }, subtitle), isActive ? /* @__PURE__ */ React__default["default"].createElement(Button, null, "Entrar") : null)))));
    };
    const renderDetailsComp = ({
      isActive,
      headline,
      dateCaption,
      userName,
      headlineAriaLabel,
      dateCaptionAriaLabel,
      avatarAriaLabel,
      statusLabel,
      showAvatarInActive
    }) => /* @__PURE__ */ React__default["default"].createElement("div", {
      style: { display: "flex", flexDirection: "row", justifyContent: "space-between" }
    }, /* @__PURE__ */ React__default["default"].createElement(DetailsConsult, null, /* @__PURE__ */ React__default["default"].createElement(DateCaption, {
      active: isActive,
      "aria-label": dateCaptionAriaLabel
    }, dateCaption), /* @__PURE__ */ React__default["default"].createElement(StyledHeadline, {
      active: isActive,
      "aria-label": headlineAriaLabel,
      color: isActive ? "blues[100]" : "black",
      mb: 3
    }, headline), /* @__PURE__ */ React__default["default"].createElement(StatusLabel, {
      active: isActive
    }, statusLabel)), showAvatarInActive || !isActive && userName ? /* @__PURE__ */ React__default["default"].createElement(RoundedAvatar, {
      "aria-label": avatarAriaLabel,
      ml: 3,
      name: userName,
      size: 32
    }) : null);

    var __defProp$b = Object.defineProperty;
    var __defProps$5 = Object.defineProperties;
    var __getOwnPropDescs$5 = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$b = Object.getOwnPropertySymbols;
    var __hasOwnProp$b = Object.prototype.hasOwnProperty;
    var __propIsEnum$b = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$b = (obj, key, value) => key in obj ? __defProp$b(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$b = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$b.call(b, prop))
          __defNormalProp$b(a, prop, b[prop]);
      if (__getOwnPropSymbols$b)
        for (var prop of __getOwnPropSymbols$b(b)) {
          if (__propIsEnum$b.call(b, prop))
            __defNormalProp$b(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$5 = (a, b) => __defProps$5(a, __getOwnPropDescs$5(b));
    const toastBase = {
      fontFamily: "normal",
      fontSize: "small",
      fontWeight: "normal",
      borderRadius: 0
    };
    const toastsTheme = __spreadProps$5(__spreadValues$b({}, toastBase), {
      primary: __spreadValues$b({
        bg: "brand.primary.97",
        color: "primary"
      }, toastBase),
      secondary: __spreadValues$b({
        bg: "lightBlues.100",
        color: "secondary"
      }, toastBase),
      muted: __spreadValues$b({
        bg: "grays.100",
        color: "muted"
      }, toastBase),
      info: __spreadValues$b({
        bg: "brand.primary.97",
        color: "primary"
      }, toastBase),
      success: __spreadValues$b({
        bg: "feedback.success.97",
        color: "feedback.success.50"
      }, toastBase),
      error: __spreadValues$b({
        bg: "feedback.danger.97",
        color: "feedback.danger.50"
      }, toastBase),
      alert: __spreadValues$b({
        bg: "feedback.alert.97",
        color: "feedback.alert.50"
      }, toastBase)
    });
    const StyledToast = styled__default["default"](themeUi.Alert)`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

    var __defProp$a = Object.defineProperty;
    var __getOwnPropSymbols$a = Object.getOwnPropertySymbols;
    var __hasOwnProp$a = Object.prototype.hasOwnProperty;
    var __propIsEnum$a = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$a = (obj, key, value) => key in obj ? __defProp$a(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$a = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$a.call(b, prop))
          __defNormalProp$a(a, prop, b[prop]);
      if (__getOwnPropSymbols$a)
        for (var prop of __getOwnPropSymbols$a(b)) {
          if (__propIsEnum$a.call(b, prop))
            __defNormalProp$a(a, prop, b[prop]);
        }
      return a;
    };
    var __objRest$9 = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$a.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$a)
        for (var prop of __getOwnPropSymbols$a(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$a.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const CustomIcon = ({ variant, icon }) => icon && /* @__PURE__ */ React__default["default"].createElement(Icon, {
      mr: 2,
      variant
    }, icon);
    const typeIcon = ({ variant, icon }) => {
      const WarningIcon = () => /* @__PURE__ */ React__default["default"].createElement(Icon, {
        mr: 2,
        size: "large",
        variant
      }, /* @__PURE__ */ React__default["default"].createElement(icons.SystemBoldWarning, null));
      switch (variant) {
        case "info":
          return /* @__PURE__ */ React__default["default"].createElement(themeUi.Spinner, {
            color: "primary",
            mr: 3,
            my: 1,
            size: 16
          });
        case "success":
          return /* @__PURE__ */ React__default["default"].createElement(Icon, {
            mr: 2,
            size: "large",
            variant
          }, /* @__PURE__ */ React__default["default"].createElement(icons.SystemBoldRoundcheckon, null));
        case "error":
          return /* @__PURE__ */ React__default["default"].createElement(WarningIcon, null);
        default:
          return CustomIcon({ variant, icon }) || /* @__PURE__ */ React__default["default"].createElement(WarningIcon, null);
      }
    };
    const Toast = (_a) => {
      var _b = _a, { variant = "info", children } = _b, props = __objRest$9(_b, ["variant", "children"]);
      return /* @__PURE__ */ React__default["default"].createElement(StyledToast, __spreadValues$a({
        sx: __spreadValues$a({}, toastsTheme[variant])
      }, props), typeIcon(__spreadValues$a({ variant }, props)), children);
    };

    var __defProp$9 = Object.defineProperty;
    var __defProps$4 = Object.defineProperties;
    var __getOwnPropDescs$4 = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$9 = Object.getOwnPropertySymbols;
    var __hasOwnProp$9 = Object.prototype.hasOwnProperty;
    var __propIsEnum$9 = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$9 = (obj, key, value) => key in obj ? __defProp$9(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$9 = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$9.call(b, prop))
          __defNormalProp$9(a, prop, b[prop]);
      if (__getOwnPropSymbols$9)
        for (var prop of __getOwnPropSymbols$9(b)) {
          if (__propIsEnum$9.call(b, prop))
            __defNormalProp$9(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$4 = (a, b) => __defProps$4(a, __getOwnPropDescs$4(b));
    var __objRest$8 = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$9.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$9)
        for (var prop of __getOwnPropSymbols$9(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$9.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const radioSxStyle = (isDisabled = false) => ({
      color: isDisabled ? "grays.70" : "grays.10",
      alignItems: "center",
      input: {
        "~ svg": {
          color: "primary"
        }
      },
      "input:disabled": {
        "~ svg": {
          color: "grays.70"
        }
      },
      "input:focus": {
        "~ svg": {
          bg: "transparent"
        }
      }
    });
    const Radio = React.forwardRef((props, ref) => {
      const _a = props, { label, sx, value, disabled } = _a, rest = __objRest$8(_a, ["label", "sx", "value", "disabled"]);
      return /* @__PURE__ */ React__default["default"].createElement(themeUi.Label, {
        sx: __spreadValues$9(__spreadValues$9({}, sx), radioSxStyle(disabled))
      }, /* @__PURE__ */ React__default["default"].createElement(themeUi.Radio, __spreadProps$4(__spreadValues$9({}, rest), {
        disabled,
        ref,
        value
      })), label);
    });

    const identity = (x) => x;

    const SearchCleanIcon = styled__default["default"](Icon)`
    box-sizing: border-box;
`;
    const SearchMagnifierIcon = styled__default["default"](Icon)`
    box-sizing: border-box;
`;
    const SearchInput = styled__default["default"](themeUi.Input)`
    border-color: transparent;
    font-family: ${({ theme }) => theme.fonts.normal};

    &:active,
    &:focus {
        border-color: transparent;
    }
`;
    const SearchContainer = styled__default["default"](Box)`
    display: flex;
    flex-direction: row;
`;
    const SearchContainerSxStyle = {
      borderWidth: 1,
      borderColor: "grays.80",
      bg: "white",
      borderRadius: "pill",
      borderStyle: "solid",
      height: "2.5em"
    };

    var __defProp$8 = Object.defineProperty;
    var __defProps$3 = Object.defineProperties;
    var __getOwnPropDescs$3 = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$8 = Object.getOwnPropertySymbols;
    var __hasOwnProp$8 = Object.prototype.hasOwnProperty;
    var __propIsEnum$8 = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$8 = (obj, key, value) => key in obj ? __defProp$8(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$8 = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$8.call(b, prop))
          __defNormalProp$8(a, prop, b[prop]);
      if (__getOwnPropSymbols$8)
        for (var prop of __getOwnPropSymbols$8(b)) {
          if (__propIsEnum$8.call(b, prop))
            __defNormalProp$8(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$3 = (a, b) => __defProps$3(a, __getOwnPropDescs$3(b));
    var __objRest$7 = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$8.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$8)
        for (var prop of __getOwnPropSymbols$8(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$8.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const Search = (_a) => {
      var _b = _a, { sx, value, onClear = identity } = _b, inputProps = __objRest$7(_b, ["sx", "value", "onClear"]);
      const isValueFilled = Boolean(value);
      const onClearEvent = isValueFilled ? onClear : identity;
      return /* @__PURE__ */ themeUi.jsx(SearchContainer, {
        sx: SearchContainerSxStyle
      }, /* @__PURE__ */ themeUi.jsx(SearchMagnifierIcon, {
        color: "primary",
        ml: 3,
        size: 5
      }, /* @__PURE__ */ themeUi.jsx(icons.SystemBoldSearch, null)), /* @__PURE__ */ themeUi.jsx(SearchInput, __spreadProps$3(__spreadValues$8({
        value
      }, inputProps), {
        sx: { border: "none" }
      })), /* @__PURE__ */ themeUi.jsx(SearchCleanIcon, {
        color: "grays.50",
        onClick: onClearEvent,
        px: 3,
        role: "button",
        size: 3
      }, /* @__PURE__ */ themeUi.jsx(icons.SystemBoldClose, {
        sx: !isValueFilled ? { visibility: "hidden" } : void 0
      })));
    };

    const AppBarStyle = {
      display: "flex",
      height: ["3em", "4em"],
      minWidth: 320,
      alignItems: "center",
      margin: 0,
      gridTemplateColumns: "repeat(3, 1fr)",
      p: 4,
      px: [4, 9],
      pr: [4, 4, 9],
      bg: "white",
      "& > span": {
        display: "flex",
        flexDirection: "row",
        alignItems: "inherit"
      }
    };

    var __defProp$7 = Object.defineProperty;
    var __getOwnPropSymbols$7 = Object.getOwnPropertySymbols;
    var __hasOwnProp$7 = Object.prototype.hasOwnProperty;
    var __propIsEnum$7 = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$7 = (obj, key, value) => key in obj ? __defProp$7(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$7 = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$7.call(b, prop))
          __defNormalProp$7(a, prop, b[prop]);
      if (__getOwnPropSymbols$7)
        for (var prop of __getOwnPropSymbols$7(b)) {
          if (__propIsEnum$7.call(b, prop))
            __defNormalProp$7(a, prop, b[prop]);
        }
      return a;
    };
    var __objRest$6 = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$7.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$7)
        for (var prop of __getOwnPropSymbols$7(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$7.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const AppBar = (_a) => {
      var _b = _a, { sx, center, left, right, children } = _b, props = __objRest$6(_b, ["sx", "center", "left", "right", "children"]);
      return /* @__PURE__ */ React__default["default"].createElement("div", null, /* @__PURE__ */ React__default["default"].createElement(Grid, __spreadValues$7({
        as: "header",
        sx: __spreadValues$7(__spreadValues$7({
          gridTemplateColumns: "repeat(3, 1fr)"
        }, AppBarStyle), sx)
      }, props), /* @__PURE__ */ React__default["default"].createElement("span", null, left), /* @__PURE__ */ React__default["default"].createElement(Spacer, null), /* @__PURE__ */ React__default["default"].createElement("span", null, center || children), /* @__PURE__ */ React__default["default"].createElement(Spacer, null), /* @__PURE__ */ React__default["default"].createElement("span", null, right)), /* @__PURE__ */ React__default["default"].createElement(Divider, {
        color: "grays.90",
        m: 0
      }));
    };

    const TabButton = styled__default["default"].button`
    font-family: inherit;
    font-size: 100%;
    line-height: 1.15;
    border: 0;
    background-color: transparent;
    padding-left: 0;
    padding-right: 0;
    font-weight: ${({ active = false }) => active ? "700" : "600"};
`;
    const TabIndicatorSxStyle = (active) => ({
      minWidth: "104px",
      minHeight: "24px",
      py: 2,
      px: 4,
      color: active ? "brand.primary.30" : "primary",
      bg: active ? "white" : "transparent",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "pill",
      textTransform: "uppercase",
      fontSize: "xsmall",
      transition: "all 200ms ease-in-out",
      mx: [0, 3]
    });
    const getPosition = (position) => {
      switch (position) {
        case "left":
          return "flex-start";
        case "right":
          return "end";
        default:
          return "center";
      }
    };
    const TabsContainer = styled__default["default"](Box)`
    display: flex;
    border-radius: ${({ theme }) => theme.radii.pill};
    background-color: ${({ theme }) => theme.colors.brand.primary[97]};
    padding: ${({ theme }) => theme.space[1]};
    justify-content: ${({ position }) => getPosition(position)};
    overflow: hidden;
    min-width: 320px;
`;
    const TabPaneContainer = styled__default["default"](Box)`
    margin-top: ${({ theme }) => theme.space.medium};
`;

    var __defProp$6 = Object.defineProperty;
    var __defProps$2 = Object.defineProperties;
    var __getOwnPropDescs$2 = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$6 = Object.getOwnPropertySymbols;
    var __hasOwnProp$6 = Object.prototype.hasOwnProperty;
    var __propIsEnum$6 = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$6 = (obj, key, value) => key in obj ? __defProp$6(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$6 = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$6.call(b, prop))
          __defNormalProp$6(a, prop, b[prop]);
      if (__getOwnPropSymbols$6)
        for (var prop of __getOwnPropSymbols$6(b)) {
          if (__propIsEnum$6.call(b, prop))
            __defNormalProp$6(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$2 = (a, b) => __defProps$2(a, __getOwnPropDescs$2(b));
    var __objRest$5 = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$6.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$6)
        for (var prop of __getOwnPropSymbols$6(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$6.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const Tab = (props) => {
      const _a = props, { active = false, tabName = "", children, onClick } = _a, rest = __objRest$5(_a, ["active", "tabName", "children", "onClick"]);
      const onTabClick = (event) => {
        event.preventDefault();
        if (onClick) {
          onClick(tabName, event);
        }
      };
      return /* @__PURE__ */ React__default["default"].createElement(TabButton, __spreadProps$2(__spreadValues$6({}, rest), {
        active,
        "aria-controls": tabName,
        "aria-selected": active,
        onClick: onTabClick,
        role: "tab"
      }), /* @__PURE__ */ React__default["default"].createElement(Box, {
        sx: __spreadValues$6({}, TabIndicatorSxStyle(active))
      }, children));
    };
    const TabPane = (_a) => {
      var _b = _a, { selected = false, forceRerender = false, tabName = "" } = _b, props = __objRest$5(_b, ["selected", "forceRerender", "tabName"]);
      const [wasSelected, setSelectedSituation] = React.useState(false);
      React.useLayoutEffect(() => {
        if (!wasSelected && selected) {
          setSelectedSituation(selected);
        }
      }, [wasSelected, selected, forceRerender]);
      const shouldRender = forceRerender ? selected : wasSelected;
      if (!shouldRender) {
        return null;
      }
      return selected ? /* @__PURE__ */ React__default["default"].createElement(TabPaneContainer, __spreadValues$6({
        "aria-labelledby": tabName,
        role: "tabpanel",
        tabIndex: 0
      }, props)) : null;
    };
    const TabPanesContainer = ({ activeTab = "", children }) => {
      const childWithProps = React__default["default"].Children.map(children, (child) => {
        var _a;
        if (!React__default["default"].isValidElement(child)) {
          return child;
        }
        const isTabSelected = Boolean(activeTab) && activeTab === ((_a = child == null ? void 0 : child.props) == null ? void 0 : _a.tabName);
        return React__default["default"].cloneElement(child, {
          selected: isTabSelected
        });
      });
      return /* @__PURE__ */ React__default["default"].createElement(React__default["default"].Fragment, null, childWithProps);
    };

    const SnackBarContainer = styled__default["default"].div`
    visibility: hidden;
    position: fixed;
    z-index: 1;
    left: 15px;
    bottom: 30px;
    opacity: 0.8;
    width: calc(100% - 30px);
    ${styledSystem.layout}
    ${styledSystem.space}

    &.show {
        visibility: visible;
        -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
        animation: fadein 0.5s, fadeout 0.5s 2.5s;
    }
`;

    var __defProp$5 = Object.defineProperty;
    var __defProps$1 = Object.defineProperties;
    var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$5 = Object.getOwnPropertySymbols;
    var __hasOwnProp$5 = Object.prototype.hasOwnProperty;
    var __propIsEnum$5 = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$5 = (obj, key, value) => key in obj ? __defProp$5(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$5 = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$5.call(b, prop))
          __defNormalProp$5(a, prop, b[prop]);
      if (__getOwnPropSymbols$5)
        for (var prop of __getOwnPropSymbols$5(b)) {
          if (__propIsEnum$5.call(b, prop))
            __defNormalProp$5(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
    var __objRest$4 = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$5.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$5)
        for (var prop of __getOwnPropSymbols$5(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$5.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const SnackBar = (_a) => {
      var _b = _a, { message, open, duration, onClose, sx, children } = _b, props = __objRest$4(_b, ["message", "open", "duration", "onClose", "sx", "children"]);
      React.useEffect(() => {
        const timer = setTimeout(() => {
          if (open) {
            onClose(false);
          }
        }, duration || 1500);
        return () => clearTimeout(timer);
      }, [onClose, open, duration]);
      return /* @__PURE__ */ themeUi.jsx(SnackBarContainer, __spreadProps$1(__spreadValues$5({}, props), {
        className: open ? "show" : "",
        sx: __spreadValues$5({
          bg: "black",
          fontSize: 1,
          color: "white",
          boxShadow: "vLow",
          borderRadius: "small",
          p: 4
        }, sx)
      }), message || children);
    };
    SnackBar.defaultProps = {
      duration: 2e3,
      open: false
    };

    const widthStyle = ({ width, fullWidth, fullMobile, mobilePosition }) => {
      const defaultWidth = 436;
      if (width) {
        return width;
      }
      if (fullWidth) {
        return "100vw";
      } else if (fullMobile || mobilePosition) {
        return ["100vw", defaultWidth];
      }
      return ["auto", defaultWidth];
    };
    const radiiCorners = (positionProp, fullMobile) => {
      const defaultRadii = "medium";
      switch (positionProp) {
        case "bottom":
        case "top":
          return [0, defaultRadii];
        default:
          return fullMobile ? [0, defaultRadii] : defaultRadii;
      }
    };
    const radiiStyle = ({ fullMobile, fullWidth, mobilePosition }) => {
      if (fullWidth) {
        return 0;
      }
      return radiiCorners(mobilePosition, fullMobile);
    };
    const heightStyle = ({ fullMobile, fullWidth }) => {
      if (fullWidth) {
        return "100vh";
      } else if (fullMobile) {
        return ["100vh", "auto"];
      }
      return "auto";
    };
    const modalSxStyle = (props) => ({
      color: "black",
      position: "relative",
      borderRadius: radiiStyle(props),
      pt: props.hideCloseButton ? 0 : 6,
      bg: "white",
      minWidth: 300,
      minHeight: 216,
      transition: "all 300ms ease-in-out",
      width: widthStyle(props),
      height: heightStyle(props),
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1e3
    });
    const ModalContainer = styled__default["default"](Box)`
    animation-duration: 200ms;
    animation-name: fadeIn;
    background-color: ${({ theme }) => theme.colors.blacks[80]};
    display: flex;
    flex: none;
    height: 100%;
    justify-content: center;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    width: 100vw;
    z-index: 999;

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

    var __defProp$4 = Object.defineProperty;
    var __getOwnPropSymbols$4 = Object.getOwnPropertySymbols;
    var __hasOwnProp$4 = Object.prototype.hasOwnProperty;
    var __propIsEnum$4 = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$4 = (obj, key, value) => key in obj ? __defProp$4(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$4 = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$4.call(b, prop))
          __defNormalProp$4(a, prop, b[prop]);
      if (__getOwnPropSymbols$4)
        for (var prop of __getOwnPropSymbols$4(b)) {
          if (__propIsEnum$4.call(b, prop))
            __defNormalProp$4(a, prop, b[prop]);
        }
      return a;
    };
    var __objRest$3 = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$4.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$4)
        for (var prop of __getOwnPropSymbols$4(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$4.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const modalPosition = (positionProp) => {
      switch (positionProp) {
        case "bottom":
          return "flex-end";
        case "top":
          return "flex-start";
        default:
          return "center";
      }
    };
    const Modal = (_a) => {
      var _b = _a, {
        width,
        onClose,
        open = false,
        children,
        fullWidth,
        fullMobile,
        sx,
        mobilePosition = "center",
        disableOutsideClick,
        hideCloseButton
      } = _b, props = __objRest$3(_b, [
        "width",
        "onClose",
        "open",
        "children",
        "fullWidth",
        "fullMobile",
        "sx",
        "mobilePosition",
        "disableOutsideClick",
        "hideCloseButton"
      ]);
      const modalRef = React.useRef(null);
      if (!open) {
        return null;
      }
      return /* @__PURE__ */ React__default["default"].createElement(ModalContainer, {
        mobilePosition,
        sx: { alignItems: [modalPosition(mobilePosition), "center"] }
      }, /* @__PURE__ */ React__default["default"].createElement(OutsideClickHandler__default["default"], {
        onOutsideClick: () => !disableOutsideClick && onClose && onClose(false)
      }, /* @__PURE__ */ React__default["default"].createElement(Box, __spreadValues$4({
        ref: modalRef,
        sx: __spreadValues$4(__spreadValues$4({}, modalSxStyle({ width, fullWidth, fullMobile, mobilePosition, hideCloseButton })), sx)
      }, props), /* @__PURE__ */ React__default["default"].createElement(Icon, {
        color: "grays.40",
        onClick: () => onClose && onClose(false),
        size: "large",
        sx: {
          position: "absolute",
          right: 4,
          top: fullWidth ? 10 : 4,
          cursor: "pointer",
          display: hideCloseButton ? "none" : "initial"
        }
      }, /* @__PURE__ */ React__default["default"].createElement(icons.SystemOutlineClose, null)), children)));
    };

    const baseBoxStyle = { display: "flex", alignItems: "center" };
    const selectBgColor = (variant) => {
      switch (variant) {
        case "muted":
          return "grays.97";
        case "danger":
        case "alert":
        case "success":
          return `feedback.${variant}.100`;
        case "primary":
        default:
          return "brand.primary.100";
      }
    };
    const listItemSxStyle = ({ selected, variant }) => ({
      width: "100%",
      bg: selected && variant ? selectBgColor(variant) : "",
      display: "flex",
      flexDirection: "column"
    });
    styled__default["default"].div`
    left: 0;
    top: 0;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    background-color: ${({ theme }) => theme.colors.blacks[80]};
    animation-name: fadeIn;
    animation-duration: 200ms;

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;
    const dividerSxStyle = ({ dividerColor, fullDivider }) => ({
      color: dividerColor,
      width: fullDivider ? "100%" : "calc(100% - 32px)",
      alignSelf: "center"
    });

    var __defProp$3 = Object.defineProperty;
    var __defProps = Object.defineProperties;
    var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
    var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
    var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$3 = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$3.call(b, prop))
          __defNormalProp$3(a, prop, b[prop]);
      if (__getOwnPropSymbols$3)
        for (var prop of __getOwnPropSymbols$3(b)) {
          if (__propIsEnum$3.call(b, prop))
            __defNormalProp$3(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
    var __objRest$2 = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$3.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$3)
        for (var prop of __getOwnPropSymbols$3(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$3.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const ListItem = (_a) => {
      var _b = _a, {
        children,
        center,
        right,
        left,
        selected = false,
        leadingIcon,
        trailingIcon,
        variant = "primary",
        indentSpace,
        noDivider,
        sx
      } = _b, props = __objRest$2(_b, [
        "children",
        "center",
        "right",
        "left",
        "selected",
        "leadingIcon",
        "trailingIcon",
        "variant",
        "indentSpace",
        "noDivider",
        "sx"
      ]);
      return /* @__PURE__ */ themeUi.jsx(Box, {
        p: 0,
        sx: __spreadValues$3({}, listItemSxStyle({ selected, variant }))
      }, /* @__PURE__ */ themeUi.jsx(Box, __spreadValues$3({
        p: indentSpace || 3,
        sx: __spreadProps(__spreadValues$3({}, baseBoxStyle), { sx })
      }, props), left || /* @__PURE__ */ themeUi.jsx(Box, {
        sx: __spreadValues$3({}, baseBoxStyle)
      }, /* @__PURE__ */ themeUi.jsx(Icon, {
        color: "accent",
        pr: 3,
        size: 4
      }, leadingIcon)), center || children, /* @__PURE__ */ themeUi.jsx(Spacer, null), right || /* @__PURE__ */ themeUi.jsx(Box, {
        sx: __spreadValues$3({}, baseBoxStyle)
      }, /* @__PURE__ */ themeUi.jsx(Icon, {
        color: variant === "danger" ? "feedback.danger.50" : variant,
        size: "large"
      }, trailingIcon))), !noDivider && /* @__PURE__ */ themeUi.jsx(Divider, {
        color: "grays.90",
        m: 0,
        sx: __spreadValues$3({}, dividerSxStyle(props))
      }));
    };

    const ContainerWaves = styled__default["default"](Box)`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
    const Waves = styled__default["default"](Box)`
    position: absolute;
    border-radius: ${({ theme }) => theme.radii.pill};

    animation: ${({ minDiameter, maxDiameter }) => ExpandAnimation(minDiameter, maxDiameter)};
    animation-duration: ${({ timeAnimation }) => timeAnimation ? timeAnimation : 4}s;
    animation-iteration-count: infinite;
`;
    const ExpandAnimation = (minDiameter, maxDiameter) => styled.keyframes`
    0% {
        width: ${minDiameter};
        height: ${minDiameter};
    }
    50% {
        width: ${maxDiameter};
        height: ${maxDiameter};
    }
    100% {
        width: ${minDiameter};
        height: ${minDiameter};
    }
`;
    const Children = styled__default["default"].div`
    position: absolute;
    min-width: 21.875em;
`;

    var __defProp$2 = Object.defineProperty;
    var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
    var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
    var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$2 = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$2.call(b, prop))
          __defNormalProp$2(a, prop, b[prop]);
      if (__getOwnPropSymbols$2)
        for (var prop of __getOwnPropSymbols$2(b)) {
          if (__propIsEnum$2.call(b, prop))
            __defNormalProp$2(a, prop, b[prop]);
        }
      return a;
    };
    var __objRest$1 = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols$2)
        for (var prop of __getOwnPropSymbols$2(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const WavesComponent = (_a) => {
      var _b = _a, {
        children,
        timeAnimation = 4,
        backgroundColor = "brand.accent.90",
        maxDiameter = "9em",
        minDiameter = "5em"
      } = _b, props = __objRest$1(_b, [
        "children",
        "timeAnimation",
        "backgroundColor",
        "maxDiameter",
        "minDiameter"
      ]);
      return /* @__PURE__ */ React__default["default"].createElement(ContainerWaves, __spreadValues$2({
        bg: "transparent"
      }, props), /* @__PURE__ */ React__default["default"].createElement(Waves, __spreadValues$2({
        bg: backgroundColor,
        maxDiameter: "17em",
        minDiameter: "13em",
        sx: { opacity: "0.2" },
        timeAnimation
      }, props)), /* @__PURE__ */ React__default["default"].createElement(Waves, __spreadValues$2({
        bg: backgroundColor,
        maxDiameter: "14.25em",
        minDiameter: "10.25em",
        sx: { opacity: "0.4" },
        timeAnimation
      }, props)), /* @__PURE__ */ React__default["default"].createElement(Waves, __spreadValues$2({
        bg: backgroundColor,
        maxDiameter: "11.5em",
        minDiameter: "7.5em",
        sx: { opacity: "0.6" },
        timeAnimation
      }, props)), /* @__PURE__ */ React__default["default"].createElement(Waves, __spreadValues$2({
        bg: backgroundColor,
        maxDiameter,
        minDiameter,
        sx: { opacity: "0.8" },
        timeAnimation
      }, props)), /* @__PURE__ */ React__default["default"].createElement(Children, null, children));
    };

    var __defProp$1 = Object.defineProperty;
    var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
    var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
    var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues$1 = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$1.call(b, prop))
          __defNormalProp$1(a, prop, b[prop]);
      if (__getOwnPropSymbols$1)
        for (var prop of __getOwnPropSymbols$1(b)) {
          if (__propIsEnum$1.call(b, prop))
            __defNormalProp$1(a, prop, b[prop]);
        }
      return a;
    };
    const Spacer = (props) => /* @__PURE__ */ React__default["default"].createElement(Box, __spreadValues$1({
      mx: "auto",
      p: 0
    }, props));

    const StyledImage = styled__default["default"](Flex)`
    max-width: 27.25em;
    flex: none;
    align-items: center;
    justify-content: center;
    min-height: 120px;
`;
    const StyledHeading = styled__default["default"](Typography)`
    font-size: ${({ theme }) => theme.fontSizes[3]};
    font-style: normal;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: ${({ theme }) => theme.space[0]};
    text-align: center;
    color: ${({ theme }) => theme.colors.black};
    max-width: 27.25em;
    width: 100%;
    margin: ${({ theme }) => theme.space[0]} auto ${({ theme }) => theme.space[2]} auto;
`;
    const Message = styled__default["default"](Box)`
    font-size: ${({ theme }) => theme.fontSizes[1]};
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: ${({ theme }) => theme.space[0]};
    text-align: center;
    margin: ${({ theme }) => theme.space[0]} auto ${({ theme }) => theme.space[6]} auto;
    color: #000000;
    max-width: 27.25em;
    min-width: 20.5em;
    width: 100%;
`;

    var __defProp = Object.defineProperty;
    var __getOwnPropSymbols = Object.getOwnPropertySymbols;
    var __hasOwnProp = Object.prototype.hasOwnProperty;
    var __propIsEnum = Object.prototype.propertyIsEnumerable;
    var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
    var __spreadValues = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      if (__getOwnPropSymbols)
        for (var prop of __getOwnPropSymbols(b)) {
          if (__propIsEnum.call(b, prop))
            __defNormalProp(a, prop, b[prop]);
        }
      return a;
    };
    var __objRest = (source, exclude) => {
      var target = {};
      for (var prop in source)
        if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
          target[prop] = source[prop];
      if (source != null && __getOwnPropSymbols)
        for (var prop of __getOwnPropSymbols(source)) {
          if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
            target[prop] = source[prop];
        }
      return target;
    };
    const GenericEmptyState = (_a) => {
      var _b = _a, { imgSrc, width, height, title, message, altImg } = _b, rest = __objRest(_b, ["imgSrc", "width", "height", "title", "message", "altImg"]);
      return /* @__PURE__ */ React__default["default"].createElement(Box, __spreadValues({}, rest), /* @__PURE__ */ React__default["default"].createElement(StyledImage, {
        sx: { mx: "auto", mb: 5, height, width }
      }, /* @__PURE__ */ React__default["default"].createElement("img", {
        alt: altImg,
        src: imgSrc
      })), /* @__PURE__ */ React__default["default"].createElement(StyledHeading, {
        as: "h1"
      }, title), /* @__PURE__ */ React__default["default"].createElement(Message, null, message));
    };

    Object.defineProperty(exports, 'AspectImage', {
        enumerable: true,
        get: function () { return themeUi.AspectImage; }
    });
    Object.defineProperty(exports, 'AspectRatio', {
        enumerable: true,
        get: function () { return themeUi.AspectRatio; }
    });
    Object.defineProperty(exports, 'Donut', {
        enumerable: true,
        get: function () { return themeUi.Donut; }
    });
    Object.defineProperty(exports, 'Image', {
        enumerable: true,
        get: function () { return themeUi.Image; }
    });
    Object.defineProperty(exports, 'Label', {
        enumerable: true,
        get: function () { return themeUi.Label; }
    });
    Object.defineProperty(exports, 'MenuButton', {
        enumerable: true,
        get: function () { return themeUi.MenuButton; }
    });
    Object.defineProperty(exports, 'Progress', {
        enumerable: true,
        get: function () { return themeUi.Progress; }
    });
    Object.defineProperty(exports, 'Slider', {
        enumerable: true,
        get: function () { return themeUi.Slider; }
    });
    Object.defineProperty(exports, 'useDasaTheme', {
        enumerable: true,
        get: function () { return themeUi.useThemeUI; }
    });
    exports.Alert = Alert;
    exports.AppBar = AppBar;
    exports.AvatarCard = AvatarCard;
    exports.BottomNavigationButtonsContainer = BottomNavigationButtonsContainer;
    exports.BottomNavigationContainer = BottomNavigationContainer;
    exports.BottomNavigationFab = BottomNavigationFab;
    exports.BottomNavigationFabButton = BottomNavigationFabButton;
    exports.BottomNavigationMenuItem = BottomNavigationMenuItem;
    exports.BottomNavigationTabsContainer = BottomNavigationTabsContainer;
    exports.Box = Box;
    exports.Button = Button$1;
    exports.Card = Card$1;
    exports.CheckBox = CheckBox;
    exports.DasaProvider = DasaProvider;
    exports.Divider = Divider;
    exports.EventCard = EventCard;
    exports.Flex = Flex;
    exports.GenericEmptyState = GenericEmptyState;
    exports.Grid = Grid;
    exports.Icon = Icon;
    exports.ListItem = ListItem;
    exports.Loading = Loading;
    exports.Modal = Modal;
    exports.Radio = Radio;
    exports.RoundedAvatar = RoundedAvatar;
    exports.Search = Search;
    exports.SnackBar = SnackBar;
    exports.Spacer = Spacer;
    exports.SquareAvatar = SquareAvatar;
    exports.Tab = Tab;
    exports.TabPane = TabPane;
    exports.TabPanesContainer = TabPanesContainer;
    exports.TabsContainer = TabsContainer;
    exports.TextField = TextField;
    exports.Toast = Toast;
    exports.Typography = Typography;
    exports.UserCard = UserCard;
    exports.Waves = WavesComponent;
    exports.almaNavTheme = almaNavTheme;
    exports.theme = theme;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=index.umd.js.map
